/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER_GOOGLE = 'LOGIN_USER_GOOGLE';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/*CATALOG LIST*/
export const ROUTE_ADMINISTRATION_GROUP = 'ROUTE_ADMINISTRATION_GROUP'
export const ROUTE_ADMINISTRATION_GROUP_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_ERROR = 'ROUTE_ADMINISTRATION_GROUP_ERROR';
export const DOSAGE_FORM_GROUP = 'DOSAGE_FORM_GROUP';
export const DOSAGE_FORM_GROUP_SUCCESS = 'DOSAGE_FORM_GROUP_SUCCESS';
export const DOSAGE_FORM_GROUP_ERROR = 'DOSAGE_FORM_GROUP_ERROR';
export const ROUTE_ADMINISTRATION = 'ROUTE_ADMINISTRATION'
export const ROUTE_ADMINISTRATION_SUCCESS = 'ROUTE_ADMINISTRATION_SUCCESS';
export const ROUTE_ADMINISTRATION_ERROR = 'ROUTE_ADMINISTRATION_ERROR';
export const DOSAGE_FORM = 'DOSAGE_FORM';
export const DOSAGE_FORM_SUCCESS = 'DOSAGE_FORM_SUCCESS';
export const DOSAGE_FORM_ERROR = 'DOSAGE_FORM_ERROR';
export const DISPENSING_UNIT = 'DISPENSING_UNIT';
export const DISPENSING_UNIT_SUCCESS = 'DISPENSING_UNIT_SUCCESS';
export const DISPENSING_UNIT_ERROR = 'DISPENSING_UNIT_ERROR';
export const UNSPSC = 'UNSPSC';
export const UNSPSC_SUCCESS = 'UNSPSC_SUCCESS';
export const UNSPSC_ERROR = 'UNSPSC_ERROR';
export const UNSPSC_FAMILY = 'UNSPSC_FAMILY';
export const UNSPSC_FAMILY_SUCCESS = 'UNSPSC_FAMILY_SUCCESS';
export const UNSPSC_FAMILY_ERROR = 'UNSPSC_FAMILY_ERROR';
export const UNSPSC_CLASS = 'UNSPSC_CLASS';
export const UNSPSC_CLASS_SUCCESS = 'UNSPSC_CLASS_SUCCESS';
export const UNSPSC_CLASS_ERROR = 'UNSPSC_CLASS_ERROR';
export const SOURCE_CODE20 = 'SOURCE_CODE20';
export const SOURCE_CODE20_SUCCESS = 'SOURCE_CODE20_SUCCESS';
export const SOURCE_CODE20_ERROR = 'SOURCE_CODE20_ERROR';
export const PROJECT = 'PROJECT';
export const PROJECT_SUCCESS = 'PROJECT_SUCCESS';
export const PROJECT_ERROR = 'PROJECT_ERROR';
export const ARTICLE_CODE22 = 'ARTICLE_CODE22';
export const ARTICLE_CODE22_SUCCESS = 'ARTICLE_CODE22_SUCCESS';
export const ARTICLE_CODE22_ERROR = 'ARTICLE_CODE22_ERROR';
export const BIDDER = 'BIDDER';
export const BIDDER_SUCCESS = 'BIDDER_SUCCESS';
export const BIDDER_ERROR = 'BIDDER_ERROR';
export const PROCESS_CODE = 'PROCESS_CODE';
export const PROCESS_CODE_SUCCESS = 'PROCESS_CODE_SUCCESS';
export const PROCESS_CODE_ERROR = 'PROCESS_CODE_ERROR';
export const COUNTRY_BID = 'COUNTRY_BID';
export const COUNTRY_BID_SUCCESS = 'COUNTRY_BID_SUCCESS';
export const COUNTRY_BID_ERROR = 'COUNTRY_BID_ERROR';
export const MED_DESCRIPTION_CODE22 = 'MED_DESCRIPTION_CODE22';
export const MED_DESCRIPTION_CODE22_SUCCESS = 'MED_DESCRIPTION_CODE22_SUCCESS';
export const MED_DESCRIPTION_CODE22_ERROR = 'MED_DESCRIPTION_CODE22_ERROR';
export const ARTICLE_TYPE = 'ARTICLE_TYPE';
export const ARTICLE_TYPE_SUCCESS = 'ARTICLE_TYPE_SUCCESS';
export const ARTICLE_TYPE_ERROR = 'ARTICLE_TYPE_ERROR';
export const ARTICLE_GROUP = 'ARTICLE_GROUP';
export const ARTICLE_GROUP_SUCCESS = 'ARTICLE_GROUP_SUCCESS';
export const ARTICLE_GROUP_ERROR = 'ARTICLE_GROUP_ERROR';
export const COUNTRY_SUPPLIER = 'COUNTRY_SUPPLIER';
export const COUNTRY_SUPPLIER_SUCCESS = 'COUNTRY_SUPPLIER_SUCCESS';
export const COUNTRY_SUPPLIER_ERROR = 'COUNTRY_SUPPLIER_ERROR';
export const SUPPLIER_TYPE = 'SUPPLIER_TYPE';
export const SUPPLIER_TYPE_SUCCESS = 'SUPPLIER_TYPE_SUCCESS';
export const SUPPLIER_TYPE_ERROR = 'SUPPLIER_TYPE_ERROR';
export const PUBLICATION_TYPE = 'PUBLICATION_TYPE';
export const PUBLICATION_TYPE_SUCCESS = 'PUBLICATION_TYPE_SUCCESS';
export const PUBLICATION_TYPE_ERROR = 'PUBLICATION_TYPE_ERROR';
export const PUBLICATION_FORMAT = 'PUBLICATION_FORMAT';
export const PUBLICATION_FORMAT_SUCCESS = 'PUBLICATION_FORMAT_SUCCESS';
export const PUBLICATION_FORMAT_ERROR = 'PUBLICATION_FORMAT_ERROR';
export const PUBLICATION_STATUS = 'PUBLICATION_STATUS';
export const PUBLICATION_STATUS_SUCCESS = 'PUBLICATION_STATUS_SUCCESS';
export const PUBLICATION_STATUS_ERROR = 'PUBLICATION_STATUS_ERROR';
export const PUBLICATION_PROJECT = 'PUBLICATION_PROJECT';
export const PUBLICATION_PROJECT_SUCCESS = 'PUBLICATION_PROJECT_SUCCESS';
export const PUBLICATION_PROJECT_ERROR = 'PUBLICATION_PROJECT_ERROR';
export const COUNTRY_OPENNING = 'COUNTRY_OPENNING';
export const COUNTRY_OPENNING_SUCCESS = 'COUNTRY_OPENNING_SUCCESS';
export const COUNTRY_OPENNING_ERROR = 'COUNTRY_OPENNING_ERROR';
export const PROCESS_CODE_BID = 'PROCESS_CODE_BID';
export const PROCESS_CODE_BID_SUCCESS = 'PROCESS_CODE_BID_SUCCESS';
export const PROCESS_CODE_BID_ERROR = 'PROCESS_CODE_BID_ERROR';
export const COUNTRY_SOURCE_CODE22 = 'COUNTRY_SOURCE_CODE22';
export const COUNTRY_SOURCE_CODE22_SUCCESS = 'COUNTRY_SOURCE_CODE22_SUCCESS';
export const COUNTRY_SOURCE_CODE22_ERROR = 'COUNTRY_SOURCE_CODE22_ERROR';
export const MED_DESCRIPTION_CODE22_ORP = 'MED_DESCRIPTION_CODE22_ORP';
export const MED_DESCRIPTION_CODE22_ORP_SUCCESS = 'MED_DESCRIPTION_CODE22_ORP_SUCCESS';
export const MED_DESCRIPTION_CODE22_ORP_ERROR = 'MED_DESCRIPTION_CODE22_ORP_ERROR';
export const SOURCE_CODE22 = 'SOURCE_CODE22';
export const SOURCE_CODE22_SUCCESS = 'SOURCE_CODE22_SUCCESS';
export const SOURCE_CODE22_ERROR = 'SOURCE_CODE22_ERROR';
export const PROCCESS_YEAR = 'PROCCESS_YEAR';
export const PROCCESS_YEAR_SUCCESS = 'PROCCESS_YEAR_SUCCESS';
export const PROCCESS_YEAR_ERROR = 'PROCCESS_YEAR_ERROR';
export const ANIO_PRICE_CODE22 = 'ANIO_PRICE_CODE22';
export const ANIO_PRICE_CODE22_SUCCESS = 'ANIO_PRICE_CODE22_SUCCESS';
export const ANIO_PRICE_CODE22_ERROR = 'ANIO_PRICE_CODE22_ERROR';
export const PROCESS_CODE_BIDDER = 'PROCESS_CODE_BIDDER';
export const PROCESS_CODE_BIDDER_SUCCESS = 'PROCESS_CODE_BIDDER_SUCCESS';
export const PROCESS_CODE_BIDDER_ERROR = 'PROCESS_CODE_BIDDER_ERROR';
export const PROCCESS_YEAR_BIDDER = 'PROCCESS_YEAR_BIDDER';
export const PROCCESS_YEAR_BIDDER_SUCCESS = 'PROCCESS_YEAR_BIDDER_SUCCESS';
export const PROCCESS_YEAR_BIDDER_ERROR = 'PROCCESS_YEAR_BIDDER_ERROR';
export const LOTE_STATE = 'LOTE_STATE';
export const LOTE_STATE_SUCCESS = 'LOTE_STATE_SUCCESS';
export const LOTE_STATE_ERROR = 'LOTE_STATE_ERROR';
export const YEAR_DEMAND = 'YEAR_DEMAND';
export const YEAR_DEMAND_SUCCESS = 'YEAR_DEMAND_SUCCESS';
export const YEAR_DEMAND_ERROR = 'YEAR_DEMAND_ERROR';
export const YEAR_GOB360 = 'YEAR_GOB360';
export const YEAR_GOB360_SUCCESS = 'YEAR_GOB360_SUCCESS';
export const YEAR_GOB360_ERROR = 'YEAR_GOB360_ERROR';
export const INSTITUTION_GOB360 = 'INSTITUTION_GOB360';
export const INSTITUTION_GOB360_SUCCESS = 'INSTITUTION_GOB360_SUCCESS';
export const INSTITUTION_GOB360_ERROR = 'INSTITUTION_GOB360_ERROR';
export const PROCESS_CODE_OPENING = 'PROCESS_CODE_OPENING';
export const PROCESS_CODE_OPENING_SUCCESS = 'PROCESS_CODE_OPENING_SUCCESS';
export const PROCESS_CODE_OPENING_ERROR = 'PROCESS_CODE_OPENING_ERROR';
export const UNIT_PRICE = 'UNIT_PRICE';
export const UNIT_PRICE_SUCCESS = 'UNIT_PRICE_SUCCESS';
export const UNIT_PRICE_ERROR = 'UNIT_PRICE_ERROR';
export const UNIT_PRICE_TRANSACCIONES = 'UNIT_PRICE_TRANSACCIONES';
export const UNIT_PRICE_TRANSACCIONES_SUCCESS = 'UNIT_PRICE_TRANSACCIONES_SUCCESS';
export const UNIT_PRICE_TRANSACCIONES_ERROR = 'UNIT_PRICE_TRANSACCIONES_ERROR';
export const LIST_ARTICLE_ORP_CODE22 = 'LIST_ARTICLE_ORP_CODE22';
export const LIST_ARTICLE_ORP_CODE22_SUCCESS = 'LIST_ARTICLE_ORP_CODE22_SUCCESS';
export const LIST_ARTICLE_ORP_CODE22_ERROR = 'LIST_ARTICLE_ORP_CODE22_ERROR';
export const LIST_ARTICLE_CODE_COUNTRY = 'LIST_ARTICLE_CODE_COUNTRY';
export const LIST_ARTICLE_CODE_COUNTRY_SUCCESS = 'LIST_ARTICLE_CODE_COUNTRY_SUCCESS';
export const LIST_ARTICLE_CODE_COUNTRY_ERROR = 'LIST_ARTICLE_CODE_COUNTRY_ERROR';
export const LIST_ARTICLE_CODE_COUNTRY_BIDDER = 'LIST_ARTICLE_CODE_COUNTRY_BIDDER';
export const LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS = 'LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS';
export const LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR = 'LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR';
export const COUNTRY_TAB_AWARD = 'COUNTRY_TAB_AWARD';
export const COUNTRY_TAB_AWARD_SUCCESS = 'COUNTRY_TAB_AWARD_SUCCESS';
export const COUNTRY_TAB_AWARD_ERROR = 'COUNTRY_TAB_AWARD_ERROR';
export const PROCCESS_CODE_TAB_AWARD = 'PROCCESS_CODE_TAB_AWARD';
export const PROCCESS_CODE_TAB_AWARD_SUCCESS = 'PROCCESS_CODE_TAB_AWARD_SUCCESS';
export const PROCCESS_CODE_TAB_AWARD_ERROR = 'PROCCESS_CODE_TAB_AWARD_ERROR';
export const YEAR_TAB_AWARD = 'YEAR_TAB_AWARD';
export const YEAR_TAB_AWARD_SUCCESS = 'YEAR_TAB_AWARD_SUCCESS';
export const YEAR_TAB_AWARD_ERROR = 'YEAR_TAB_AWARD_ERROR';
export const PROCCESS_CODE_TAB_OPENNING = 'PROCCESS_CODE_TAB_OPENNING';
export const PROCCESS_CODE_TAB_OPENNING_SUCCESS = 'PROCCESS_CODE_TAB_OPENNING_SUCCESS';
export const PROCCESS_CODE_TAB_OPENNING_ERROR = 'PROCCESS_CODE_TAB_OPENNING_ERROR';
export const YEAR_TAB_OPENNING = 'YEAR_TAB_OPENNING';
export const YEAR_TAB_OPENNING_SUCCESS = 'YEAR_TAB_OPENNING_SUCCESS';
export const YEAR_TAB_OPENNING_ERROR = 'YEAR_TAB_OPENNING_ERROR';
export const COUNTRY_TAB_OPENNING = 'COUNTRY_TAB_OPENNING';
export const COUNTRY_TAB_OPENNING_SUCCESS = 'COUNTRY_TAB_OPENNING_SUCCESS';
export const COUNTRY_TAB_OPENNING_ERROR = 'COUNTRY_TAB_OPENNING_ERROR';
export const ARTICLE_CODE22_SUPPLIER = 'ARTICLE_CODE22_SUPPLIER';
export const ARTICLE_CODE22_SUPPLIER_SUCCESS = 'ARTICLE_CODE22_SUPPLIER_SUCCESS';
export const ARTICLE_CODE22_SUPPLIER_ERROR = 'ARTICLE_CODE22_SUPPLIER_ERROR';
export const ARTICLE_CODE_COUNTRY_SUPPLIER = 'ARTICLE_CODE_COUNTRY_SUPPLIER';
export const ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS = 'ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS';
export const ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR = 'ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR';
export const COUNTRY_SUPPLIER_INFO = 'COUNTRY_SUPPLIER_INFO';
export const COUNTRY_SUPPLIER_INFO_SUCCESS = 'COUNTRY_SUPPLIER_INFO_SUCCESS';
export const COUNTRY_SUPPLIER_INFO_ERROR = 'COUNTRY_SUPPLIER_INFO_ERROR';
export const SUPPLIER_INFO = 'SUPPLIER_INFO';
export const SUPPLIER_INFO_SUCCESS = 'SUPPLIER_INFO_SUCCESS';
export const SUPPLIER_INFO_ERROR = 'SUPPLIER_INFO_ERROR';
export const MED_DESCRIPTION_RAZONABILIDAD = 'MED_DESCRIPTION_RAZONABILIDAD';
export const MED_DESCRIPTION_RAZONABILIDAD_SUCCESS = 'MED_DESCRIPTION_RAZONABILIDAD_SUCCESS';
export const MED_DESCRIPTION_RAZONABILIDAD_ERROR = 'MED_DESCRIPTION_RAZONABILIDAD_ERROR';
export const LIST_ARTICLE_RAZONABILIDAD = 'LIST_ARTICLE_RAZONABILIDAD';
export const LIST_ARTICLE_RAZONABILIDAD_SUCCESS = 'LIST_ARTICLE_RAZONABILIDAD_SUCCESS';
export const LIST_ARTICLE_RAZONABILIDAD_ERROR = 'LIST_ARTICLE_RAZONABILIDAD_ERROR';
export const COUNTRY_AWARD = 'COUNTRY_AWARD';
export const COUNTRY_AWARD_SUCCESS = 'COUNTRY_AWARD_SUCCESS';
export const COUNTRY_AWARD_ERROR = 'COUNTRY_AWARD_ERROR';
export const ROLE = 'ROLE';
export const ROLE_SUCCESS = 'ROLE_SUCCESS';
export const ROLE_ERROR = 'ROLE_ERROR';
export const ROLE_ORP = 'ROLE_ORP';
export const ROLE_ORP_SUCCESS = 'ROLE_ORP_SUCCESS';
export const ROLE_ORP_ERROR = 'ROLE_ORP_ERROR';


/*ACTIVE INGREDIENT*/
export const ACTIVE_INGREDIENT_LIST = 'ACTIVE_INGREDIENT_LIST';
export const ACTIVE_INGREDIENT_LIST_SUCCESS = 'ACTIVE_INGREDIENT_LIST_SUCCESS';
export const ACTIVE_INGREDIENT_LIST_ERROR = 'ACTIVE_INGREDIENT_LIST_ERROR';
export const ACTIVE_INGREDIENT_PAGE_SET = 'ACTIVE_INGREDIENT_PAGE_SET';
export const ACTIVE_INGREDIENT_HEADER = 'ACTIVE_INGREDIENT_HEADER';
export const ACTIVE_INGREDIENT_SEARCH_SET = 'ACTIVE_INGREDIENT_SEARCH_SET';
export const ACTIVE_INGREDIENT_SEARCH_CHANGE = 'ACTIVE_INGREDIENT_SEARCH_CHANGE';
export const ACTIVE_INGREDIENT_ADD_SET = 'ACTIVE_INGREDIENT_ADD_SET';
export const ACTIVE_INGREDIENT_ADD_MODAL_SET = 'ACTIVE_INGREDIENT_ADD_MODAL_SET';
export const ACTIVE_INGREDIENT_ADD = 'ACTIVE_INGREDIENT_ADD';
export const ACTIVE_INGREDIENT_ADD_SUCCESS = 'ACTIVE_INGREDIENT_ADD_SUCCESS';
export const ACTIVE_INGREDIENT_ADD_ERROR = 'ACTIVE_INGREDIENT_ADD_ERROR';
export const ACTIVE_INGREDIENT_ADD_CHANGE = 'ACTIVE_INGREDIENT_ADD_CHANGE';
export const ACTIVE_INGREDIENT_EDIT_SET = 'ACTIVE_INGREDIENT_EDIT_SET';
export const ACTIVE_INGREDIENT_EDIT_CHANGE = 'ACTIVE_INGREDIENT_EDIT_CHANGE';
export const ACTIVE_INGREDIENT_EDIT_MODAL_SET = 'ACTIVE_INGREDIENT_EDIT_MODAL_SET';
export const ACTIVE_INGREDIENT_DETAIL = 'ACTIVE_INGREDIENT_DETAIL';
export const ACTIVE_INGREDIENT_DETAIL_SUCCESS = 'ACTIVE_INGREDIENT_DETAIL_SUCCESS';
export const ACTIVE_INGREDIENT_DETAIL_ERROR = 'ACTIVE_INGREDIENT_DETAIL_ERROR';
export const ACTIVE_INGREDIENT_UPDATE = 'ACTIVE_INGREDIENT_UPDATE';
export const ACTIVE_INGREDIENT_UPDATE_SUCCESS = 'ACTIVE_INGREDIENT_UPDATE_SUCCESS';
export const ACTIVE_INGREDIENT_UPDATE_ERROR = 'ACTIVE_INGREDIENT_UPDATE_ERROR';

/*UNIT*/
export const UNIT_LIST = 'UNIT_LIST';
export const UNIT_LIST_SUCCESS = 'UNIT_LIST_SUCCESS';
export const UNIT_LIST_ERROR = 'UNIT_LIST_ERROR';
export const UNIT_PAGE_SET = 'UNIT_PAGE_SET';
export const UNIT_HEADER = 'UNIT_HEADER';
export const UNIT_SEARCH_SET = 'UNIT_SEARCH_SET';
export const UNIT_SEARCH_CHANGE = 'UNIT_SEARCH_CHANGE';
export const UNIT_ADD_SET = 'UNIT_ADD_SET';
export const UNIT_ADD_MODAL_SET = 'UNIT_ADD_MODAL_SET';
export const UNIT_ADD = 'UNIT_ADD';
export const UNIT_ADD_SUCCESS = 'UNIT_ADD_SUCCESS';
export const UNIT_ADD_ERROR = 'UNIT_ADD_ERROR';
export const UNIT_ADD_CHANGE = 'UNIT_ADD_CHANGE';
export const UNIT_EDIT_SET = 'UNIT_EDIT_SET';
export const UNIT_EDIT_CHANGE = 'UNIT_EDIT_CHANGE';
export const UNIT_EDIT_MODAL_SET = 'UNIT_EDIT_MODAL_SET';
export const UNIT_DETAIL = 'UNIT_DETAIL';
export const UNIT_DETAIL_SUCCESS = 'UNIT_DETAIL_SUCCESS';
export const UNIT_DETAIL_ERROR = 'UNIT_DETAIL_ERROR';
export const UNIT_UPDATE = 'UNIT_UPDATE';
export const UNIT_UPDATE_SUCCESS = 'UNIT_UPDATE_SUCCESS';
export const UNIT_UPDATE_ERROR = 'UNIT_UPDATE_ERROR';

/*DOSAGE FORM*/
export const DOSAGE_FORM_LIST = 'DOSAGE_FORM_LIST';
export const DOSAGE_FORM_LIST_SUCCESS = 'DOSAGE_FORM_LIST_SUCCESS';
export const DOSAGE_FORM_LIST_ERROR = 'DOSAGE_FORM_LIST_ERROR';
export const DOSAGE_FORM_PAGE_SET = 'DOSAGE_FORM_PAGE_SET';
export const DOSAGE_FORM_HEADER = 'DOSAGE_FORM_HEADER';
export const DOSAGE_FORM_SEARCH_SET = 'DOSAGE_FORM_SEARCH_SET';
export const DOSAGE_FORM_SEARCH_CHANGE = 'DOSAGE_FORM_SEARCH_CHANGE';
export const DOSAGE_FORM_ADD_SET = 'DOSAGE_FORM_ADD_SET';
export const DOSAGE_FORM_ADD_MODAL_SET = 'DOSAGE_FORM_ADD_MODAL_SET';
export const DOSAGE_FORM_ADD = 'DOSAGE_FORM_ADD';
export const DOSAGE_FORM_ADD_SUCCESS = 'DOSAGE_FORM_ADD_SUCCESS';
export const DOSAGE_FORM_ADD_ERROR = 'DOSAGE_FORM_ADD_ERROR';
export const DOSAGE_FORM_ADD_CHANGE = 'DOSAGE_FORM_ADD_CHANGE';
export const DOSAGE_FORM_EDIT_SET = 'DOSAGE_FORM_EDIT_SET';
export const DOSAGE_FORM_EDIT_CHANGE = 'DOSAGE_FORM_EDIT_CHANGE';
export const DOSAGE_FORM_EDIT_MODAL_SET = 'DOSAGE_FORM_EDIT_MODAL_SET';
export const DOSAGE_FORM_DETAIL = 'DOSAGE_FORM_DETAIL';
export const DOSAGE_FORM_DETAIL_SUCCESS = 'DOSAGE_FORM_DETAIL_SUCCESS';
export const DOSAGE_FORM_DETAIL_ERROR = 'DOSAGE_FORM_DETAIL_ERROR';
export const DOSAGE_FORM_UPDATE = 'DOSAGE_FORM_UPDATE';
export const DOSAGE_FORM_UPDATE_SUCCESS = 'DOSAGE_FORM_UPDATE_SUCCESS';
export const DOSAGE_FORM_UPDATE_ERROR = 'DOSAGE_FORM_UPDATE_ERROR';

/*DOSAGE FORM GROUP*/
export const DOSAGE_FORM_GROUP_LIST = 'DOSAGE_FORM_GROUP_LIST';
export const DOSAGE_FORM_GROUP_LIST_SUCCESS = 'DOSAGE_FORM_GROUP_LIST_SUCCESS';
export const DOSAGE_FORM_GROUP_LIST_ERROR = 'DOSAGE_FORM_GROUP_LIST_ERROR';
export const DOSAGE_FORM_GROUP_PAGE_SET = 'DOSAGE_FORM_GROUP_PAGE_SET';
export const DOSAGE_FORM_GROUP_HEADER = 'DOSAGE_FORM_GROUP_HEADER';
export const DOSAGE_FORM_GROUP_SEARCH_SET = 'DOSAGE_FORM_GROUP_SEARCH_SET';
export const DOSAGE_FORM_GROUP_SEARCH_CHANGE = 'DOSAGE_FORM_GROUP_SEARCH_CHANGE';
export const DOSAGE_FORM_GROUP_ADD_SET = 'DOSAGE_FORM_GROUP_ADD_SET';
export const DOSAGE_FORM_GROUP_ADD_MODAL_SET = 'DOSAGE_FORM_GROUP_ADD_MODAL_SET';
export const DOSAGE_FORM_GROUP_ADD = 'DOSAGE_FORM_GROUP_ADD';
export const DOSAGE_FORM_GROUP_ADD_SUCCESS = 'DOSAGE_FORM_GROUP_ADD_SUCCESS';
export const DOSAGE_FORM_GROUP_ADD_ERROR = 'DOSAGE_FORM_GROUP_ADD_ERROR';
export const DOSAGE_FORM_GROUP_ADD_CHANGE = 'DOSAGE_FORM_GROUP_ADD_CHANGE';
export const DOSAGE_FORM_GROUP_EDIT_SET = 'DOSAGE_FORM_GROUP_EDIT_SET';
export const DOSAGE_FORM_GROUP_EDIT_CHANGE = 'DOSAGE_FORM_GROUP_EDIT_CHANGE';
export const DOSAGE_FORM_GROUP_EDIT_MODAL_SET = 'DOSAGE_FORM_GROUP_EDIT_MODAL_SET';
export const DOSAGE_FORM_GROUP_DETAIL = 'DOSAGE_FORM_GROUP_DETAIL';
export const DOSAGE_FORM_GROUP_DETAIL_SUCCESS = 'DOSAGE_FORM_GROUP_DETAIL_SUCCESS';
export const DOSAGE_FORM_GROUP_DETAIL_ERROR = 'DOSAGE_FORM_GROUP_DETAIL_ERROR';
export const DOSAGE_FORM_GROUP_UPDATE = 'DOSAGE_FORM_GROUP_UPDATE';
export const DOSAGE_FORM_GROUP_UPDATE_SUCCESS = 'DOSAGE_FORM_GROUP_UPDATE_SUCCESS';
export const DOSAGE_FORM_GROUP_UPDATE_ERROR = 'DOSAGE_FORM_GROUP_UPDATE_ERROR';

/*SALT*/
export const SALT_LIST = 'SALT_LIST';
export const SALT_LIST_SUCCESS = 'SALT_LIST_SUCCESS';
export const SALT_LIST_ERROR = 'SALT_LIST_ERROR';
export const SALT_PAGE_SET = 'SALT_PAGE_SET';
export const SALT_HEADER = 'SALT_HEADER';
export const SALT_SEARCH_SET = 'SALT_SEARCH_SET';
export const SALT_SEARCH_CHANGE = 'SALT_SEARCH_CHANGE';
export const SALT_ADD_SET = 'SALT_ADD_SET';
export const SALT_ADD_MODAL_SET = 'SALT_ADD_MODAL_SET';
export const SALT_ADD = 'SALT_ADD';
export const SALT_ADD_SUCCESS = 'SALT_ADD_SUCCESS';
export const SALT_ADD_ERROR = 'SALT_ADD_ERROR';
export const SALT_ADD_CHANGE = 'SALT_ADD_CHANGE';
export const SALT_EDIT_SET = 'SALT_EDIT_SET';
export const SALT_EDIT_CHANGE = 'SALT_EDIT_CHANGE';
export const SALT_EDIT_MODAL_SET = 'SALT_EDIT_MODAL_SET';
export const SALT_DETAIL = 'SALT_DETAIL';
export const SALT_DETAIL_SUCCESS = 'SALT_DETAIL_SUCCESS';
export const SALT_DETAIL_ERROR = 'SALT_DETAIL_ERROR';
export const SALT_UPDATE = 'SALT_UPDATE';
export const SALT_UPDATE_SUCCESS = 'SALT_UPDATE_SUCCESS';
export const SALT_UPDATE_ERROR = 'SALT_UPDATE_ERROR';

/*DISPENSING_UNIT*/
export const DISPENSING_UNIT_LIST = 'DISPENSING_UNIT_LIST';
export const DISPENSING_UNIT_LIST_SUCCESS = 'DISPENSING_UNIT_LIST_SUCCESS';
export const DISPENSING_UNIT_LIST_ERROR = 'DISPENSING_UNIT_LIST_ERROR';
export const DISPENSING_UNIT_PAGE_SET = 'DISPENSING_UNIT_PAGE_SET';
export const DISPENSING_UNIT_HEADER = 'DISPENSING_UNIT_HEADER';
export const DISPENSING_UNIT_SEARCH_SET = 'DISPENSING_UNIT_SEARCH_SET';
export const DISPENSING_UNIT_SEARCH_CHANGE = 'DISPENSING_UNIT_SEARCH_CHANGE';
export const DISPENSING_UNIT_ADD_SET = 'DISPENSING_UNIT_ADD_SET';
export const DISPENSING_UNIT_ADD_MODAL_SET = 'DISPENSING_UNIT_ADD_MODAL_SET';
export const DISPENSING_UNIT_ADD = 'DISPENSING_UNIT_ADD';
export const DISPENSING_UNIT_ADD_SUCCESS = 'DISPENSING_UNIT_ADD_SUCCESS';
export const DISPENSING_UNIT_ADD_ERROR = 'DISPENSING_UNIT_ADD_ERROR';
export const DISPENSING_UNIT_ADD_CHANGE = 'DISPENSING_UNIT_ADD_CHANGE';
export const DISPENSING_UNIT_EDIT_SET = 'DISPENSING_UNIT_EDIT_SET';
export const DISPENSING_UNIT_EDIT_CHANGE = 'DISPENSING_UNIT_EDIT_CHANGE';
export const DISPENSING_UNIT_EDIT_MODAL_SET = 'DISPENSING_UNIT_EDIT_MODAL_SET';
export const DISPENSING_UNIT_DETAIL = 'DISPENSING_UNIT_DETAIL';
export const DISPENSING_UNIT_DETAIL_SUCCESS = 'DISPENSING_UNIT_DETAIL_SUCCESS';
export const DISPENSING_UNIT_DETAIL_ERROR = 'DISPENSING_UNIT_DETAIL_ERROR';
export const DISPENSING_UNIT_UPDATE = 'DISPENSING_UNIT_UPDATE';
export const DISPENSING_UNIT_UPDATE_SUCCESS = 'DISPENSING_UNIT_UPDATE_SUCCESS';
export const DISPENSING_UNIT_UPDATE_ERROR = 'DISPENSING_UNIT_UPDATE_ERROR';

/*ROUTE_ADMINISTRATION*/
export const ROUTE_ADMINISTRATION_LIST = 'ROUTE_ADMINISTRATION_LIST';
export const ROUTE_ADMINISTRATION_LIST_SUCCESS = 'ROUTE_ADMINISTRATION_LIST_SUCCESS';
export const ROUTE_ADMINISTRATION_LIST_ERROR = 'ROUTE_ADMINISTRATION_LIST_ERROR';
export const ROUTE_ADMINISTRATION_PAGE_SET = 'ROUTE_ADMINISTRATION_PAGE_SET';
export const ROUTE_ADMINISTRATION_HEADER = 'ROUTE_ADMINISTRATION_HEADER';
export const ROUTE_ADMINISTRATION_SEARCH_SET = 'ROUTE_ADMINISTRATION_SEARCH_SET';
export const ROUTE_ADMINISTRATION_SEARCH_CHANGE = 'ROUTE_ADMINISTRATION_SEARCH_CHANGE';
export const ROUTE_ADMINISTRATION_ADD_SET = 'ROUTE_ADMINISTRATION_ADD_SET';
export const ROUTE_ADMINISTRATION_ADD_MODAL_SET = 'ROUTE_ADMINISTRATION_ADD_MODAL_SET';
export const ROUTE_ADMINISTRATION_ADD = 'ROUTE_ADMINISTRATION_ADD';
export const ROUTE_ADMINISTRATION_ADD_SUCCESS = 'ROUTE_ADMINISTRATION_ADD_SUCCESS';
export const ROUTE_ADMINISTRATION_ADD_ERROR = 'ROUTE_ADMINISTRATION_ADD_ERROR';
export const ROUTE_ADMINISTRATION_ADD_CHANGE = 'ROUTE_ADMINISTRATION_ADD_CHANGE';
export const ROUTE_ADMINISTRATION_EDIT_SET = 'ROUTE_ADMINISTRATION_EDIT_SET';
export const ROUTE_ADMINISTRATION_EDIT_CHANGE = 'ROUTE_ADMINISTRATION_EDIT_CHANGE';
export const ROUTE_ADMINISTRATION_EDIT_MODAL_SET = 'ROUTE_ADMINISTRATION_EDIT_MODAL_SET';
export const ROUTE_ADMINISTRATION_DETAIL = 'ROUTE_ADMINISTRATION_DETAIL';
export const ROUTE_ADMINISTRATION_DETAIL_SUCCESS = 'ROUTE_ADMINISTRATION_DETAIL_SUCCESS';
export const ROUTE_ADMINISTRATION_DETAIL_ERROR = 'ROUTE_ADMINISTRATION_DETAIL_ERROR';
export const ROUTE_ADMINISTRATION_UPDATE = 'ROUTE_ADMINISTRATION_UPDATE';
export const ROUTE_ADMINISTRATION_UPDATE_SUCCESS = 'ROUTE_ADMINISTRATION_UPDATE_SUCCESS';
export const ROUTE_ADMINISTRATION_UPDATE_ERROR = 'ROUTE_ADMINISTRATION_UPDATE_ERROR';

/*ROUTE_ADMINISTRATION GROUP*/
export const ROUTE_ADMINISTRATION_GROUP_LIST = 'ROUTE_ADMINISTRATION_GROUP_LIST';
export const ROUTE_ADMINISTRATION_GROUP_LIST_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_LIST_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_LIST_ERROR = 'ROUTE_ADMINISTRATION_GROUP_LIST_ERROR';
export const ROUTE_ADMINISTRATION_GROUP_PAGE_SET = 'ROUTE_ADMINISTRATION_GROUP_PAGE_SET';
export const ROUTE_ADMINISTRATION_GROUP_HEADER = 'ROUTE_ADMINISTRATION_GROUP_HEADER';
export const ROUTE_ADMINISTRATION_GROUP_SEARCH_SET = 'ROUTE_ADMINISTRATION_GROUP_SEARCH_SET';
export const ROUTE_ADMINISTRATION_GROUP_SEARCH_CHANGE = 'ROUTE_ADMINISTRATION_GROUP_SEARCH_CHANGE';
export const ROUTE_ADMINISTRATION_GROUP_ADD_SET = 'ROUTE_ADMINISTRATION_GROUP_ADD_SET';
export const ROUTE_ADMINISTRATION_GROUP_ADD_MODAL_SET = 'ROUTE_ADMINISTRATION_GROUP_ADD_MODAL_SET';
export const ROUTE_ADMINISTRATION_GROUP_ADD = 'ROUTE_ADMINISTRATION_GROUP_ADD';
export const ROUTE_ADMINISTRATION_GROUP_ADD_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_ADD_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_ADD_ERROR = 'ROUTE_ADMINISTRATION_GROUP_ADD_ERROR';
export const ROUTE_ADMINISTRATION_GROUP_ADD_CHANGE = 'ROUTE_ADMINISTRATION_GROUP_ADD_CHANGE';
export const ROUTE_ADMINISTRATION_GROUP_EDIT_SET = 'ROUTE_ADMINISTRATION_GROUP_EDIT_SET';
export const ROUTE_ADMINISTRATION_GROUP_EDIT_CHANGE = 'ROUTE_ADMINISTRATION_GROUP_EDIT_CHANGE';
export const ROUTE_ADMINISTRATION_GROUP_EDIT_MODAL_SET = 'ROUTE_ADMINISTRATION_GROUP_EDIT_MODAL_SET';
export const ROUTE_ADMINISTRATION_GROUP_DETAIL = 'ROUTE_ADMINISTRATION_GROUP_DETAIL';
export const ROUTE_ADMINISTRATION_GROUP_DETAIL_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_DETAIL_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_DETAIL_ERROR = 'ROUTE_ADMINISTRATION_GROUP_DETAIL_ERROR';
export const ROUTE_ADMINISTRATION_GROUP_UPDATE = 'ROUTE_ADMINISTRATION_GROUP_UPDATE';
export const ROUTE_ADMINISTRATION_GROUP_UPDATE_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_UPDATE_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_UPDATE_ERROR = 'ROUTE_ADMINISTRATION_GROUP_UPDATE_ERROR';

/*UNSPSC FAMILY*/
export const UNSPSC_FAMILY_LIST = 'UNSPSC_FAMILY_LIST';
export const UNSPSC_FAMILY_LIST_SUCCESS = 'UNSPSC_FAMILY_LIST_SUCCESS';
export const UNSPSC_FAMILY_LIST_ERROR = 'UNSPSC_FAMILY_LIST_ERROR';
export const UNSPSC_FAMILY_PAGE_SET = 'UNSPSC_FAMILY_PAGE_SET';
export const UNSPSC_FAMILY_HEADER = 'UNSPSC_FAMILY_HEADER';
export const UNSPSC_FAMILY_SEARCH_SET = 'UNSPSC_FAMILY_SEARCH_SET';
export const UNSPSC_FAMILY_SEARCH_CHANGE = 'UNSPSC_FAMILY_SEARCH_CHANGE';
export const UNSPSC_FAMILY_ADD_SET = 'UNSPSC_FAMILY_ADD_SET';
export const UNSPSC_FAMILY_ADD_MODAL_SET = 'UNSPSC_FAMILY_ADD_MODAL_SET';
export const UNSPSC_FAMILY_ADD = 'UNSPSC_FAMILY_ADD';
export const UNSPSC_FAMILY_ADD_SUCCESS = 'UNSPSC_FAMILY_ADD_SUCCESS';
export const UNSPSC_FAMILY_ADD_ERROR = 'UNSPSC_FAMILY_ADD_ERROR';
export const UNSPSC_FAMILY_ADD_CHANGE = 'UNSPSC_FAMILY_ADD_CHANGE';
export const UNSPSC_FAMILY_EDIT_SET = 'UNSPSC_FAMILY_EDIT_SET';
export const UNSPSC_FAMILY_EDIT_CHANGE = 'UNSPSC_FAMILY_EDIT_CHANGE';
export const UNSPSC_FAMILY_EDIT_MODAL_SET = 'UNSPSC_FAMILY_EDIT_MODAL_SET';
export const UNSPSC_FAMILY_DETAIL = 'UNSPSC_FAMILY_DETAIL';
export const UNSPSC_FAMILY_DETAIL_SUCCESS = 'UNSPSC_FAMILY_DETAIL_SUCCESS';
export const UNSPSC_FAMILY_DETAIL_ERROR = 'UNSPSC_FAMILY_DETAIL_ERROR';
export const UNSPSC_FAMILY_UPDATE = 'UNSPSC_FAMILY_UPDATE';
export const UNSPSC_FAMILY_UPDATE_SUCCESS = 'UNSPSC_FAMILY_UPDATE_SUCCESS';
export const UNSPSC_FAMILY_UPDATE_ERROR = 'UNSPSC_FAMILY_UPDATE_ERROR';

/*UNSPSC CLASS*/
export const UNSPSC_CLASS_LIST = 'UNSPSC_CLASS_LIST';
export const UNSPSC_CLASS_LIST_SUCCESS = 'UNSPSC_CLASS_LIST_SUCCESS';
export const UNSPSC_CLASS_LIST_ERROR = 'UNSPSC_CLASS_LIST_ERROR';
export const UNSPSC_CLASS_PAGE_SET = 'UNSPSC_CLASS_PAGE_SET';
export const UNSPSC_CLASS_HEADER = 'UNSPSC_CLASS_HEADER';
export const UNSPSC_CLASS_SEARCH_SET = 'UNSPSC_CLASS_SEARCH_SET';
export const UNSPSC_CLASS_SEARCH_CHANGE = 'UNSPSC_CLASS_SEARCH_CHANGE';
export const UNSPSC_CLASS_ADD_SET = 'UNSPSC_CLASS_ADD_SET';
export const UNSPSC_CLASS_ADD_MODAL_SET = 'UNSPSC_CLASS_ADD_MODAL_SET';
export const UNSPSC_CLASS_ADD = 'UNSPSC_CLASS_ADD';
export const UNSPSC_CLASS_ADD_SUCCESS = 'UNSPSC_CLASS_ADD_SUCCESS';
export const UNSPSC_CLASS_ADD_ERROR = 'UNSPSC_CLASS_ADD_ERROR';
export const UNSPSC_CLASS_ADD_CHANGE = 'UNSPSC_CLASS_ADD_CHANGE';
export const UNSPSC_CLASS_EDIT_SET = 'UNSPSC_CLASS_EDIT_SET';
export const UNSPSC_CLASS_EDIT_CHANGE = 'UNSPSC_CLASS_EDIT_CHANGE';
export const UNSPSC_CLASS_EDIT_MODAL_SET = 'UNSPSC_CLASS_EDIT_MODAL_SET';
export const UNSPSC_CLASS_DETAIL = 'UNSPSC_CLASS_DETAIL';
export const UNSPSC_CLASS_DETAIL_SUCCESS = 'UNSPSC_CLASS_DETAIL_SUCCESS';
export const UNSPSC_CLASS_DETAIL_ERROR = 'UNSPSC_CLASS_DETAIL_ERROR';
export const UNSPSC_CLASS_UPDATE = 'UNSPSC_CLASS_UPDATE';
export const UNSPSC_CLASS_UPDATE_SUCCESS = 'UNSPSC_CLASS_UPDATE_SUCCESS';
export const UNSPSC_CLASS_UPDATE_ERROR = 'UNSPSC_CLASS_UPDATE_ERROR';

/*UNSPSC */
export const UNSPSC_LIST = 'UNSPSC_LIST';
export const UNSPSC_LIST_SUCCESS = 'UNSPSC_LIST_SUCCESS';
export const UNSPSC_LIST_ERROR = 'UNSPSC_LIST_ERROR';
export const UNSPSC_PAGE_SET = 'UNSPSC_PAGE_SET';
export const UNSPSC_HEADER = 'UNSPSC_HEADER';
export const UNSPSC_SEARCH_SET = 'UNSPSC_SEARCH_SET';
export const UNSPSC_SEARCH_CHANGE = 'UNSPSC_SEARCH_CHANGE';
export const UNSPSC_ADD_SET = 'UNSPSC_ADD_SET';
export const UNSPSC_ADD_MODAL_SET = 'UNSPSC_ADD_MODAL_SET';
export const UNSPSC_ADD = 'UNSPSC_ADD';
export const UNSPSC_ADD_SUCCESS = 'UNSPSC_ADD_SUCCESS';
export const UNSPSC_ADD_ERROR = 'UNSPSC_ADD_ERROR';
export const UNSPSC_ADD_CHANGE = 'UNSPSC_ADD_CHANGE';
export const UNSPSC_EDIT_SET = 'UNSPSC_EDIT_SET';
export const UNSPSC_EDIT_CHANGE = 'UNSPSC_EDIT_CHANGE';
export const UNSPSC_EDIT_MODAL_SET = 'UNSPSC_EDIT_MODAL_SET';
export const UNSPSC_DETAIL = 'UNSPSC_DETAIL';
export const UNSPSC_DETAIL_SUCCESS = 'UNSPSC_DETAIL_SUCCESS';
export const UNSPSC_DETAIL_ERROR = 'UNSPSC_DETAIL_ERROR';
export const UNSPSC_UPDATE = 'UNSPSC_UPDATE';
export const UNSPSC_UPDATE_SUCCESS = 'UNSPSC_UPDATE_SUCCESS';
export const UNSPSC_UPDATE_ERROR = 'UNSPSC_UPDATE_ERROR';


/*DATA MEDICATION*/
export const DATA_MEDICATION_LIST = 'DATA_MEDICATION_LIST';
export const DATA_MEDICATION_LIST_SUCCESS = 'DATA_MEDICATION_LIST_SUCCESS';
export const DATA_MEDICATION_LIST_ERROR = 'DATA_MEDICATION_LIST_ERROR';
export const DATA_MEDICATION_PAGE_SET = 'DATA_MEDICATION_PAGE_SET';
export const DATA_MEDICATION_HEADER = 'DATA_MEDICATION_HEADER';
export const DATA_MEDICATION_SEARCH_SET = 'DATA_MEDICATION_SEARCH_SET';
export const DATA_MEDICATION_SEARCH_CHANGE = 'DATA_MEDICATION_SEARCH_CHANGE';

/*ATC*/
export const ATC_LIST = 'ATC_LIST';
export const ATC_LIST_SUCCESS = 'ATC_LIST_SUCCESS';
export const ATC_LIST_ERROR = 'ATC_LIST_ERROR';

/*NEWS*/
export const NEWS_DETAIL = 'NEWS_DETAIL';
export const NEWS_DETAIL_SUCCESS = 'NEWS_DETAIL_SUCCESS';
export const NEWS_DETAIL_ERROR = 'NEWS_DETAIL_ERROR';

/* ARTICLE */
export const ARTICLE_LIST = 'ARTICLE_LIST';
export const ARTICLE_LIST_SUCCESS = 'ARTICLE_LIST_SUCCESS';
export const ARTICLE_LIST_ERROR = 'ARTICLE_LIST_ERROR';
export const ARTICLE_SEARCH_ARTICLE_GROUP_LIST = 'ARTICLE_SEARCH_ARTICLE_GROUP_LIST';
export const ARTICLE_SEARCH_ARTICLE_GROUP_LIST_SUCCESS = 'ARTICLE_SEARCH_ARTICLE_GROUP_LIST_SUCCESS';
export const ARTICLE_SEARCH_ARTICLE_GROUP_LIST_ERROR = 'ARTICLE_SEARCH_ARTICLE_GROUP_LIST_ERROR';
export const ARTICLE_SEARCH_SET= 'ARTICLE_SEARCH_SET';
export const ARTICLE_PAGE_SET= 'ARTICLE_PAGE_SET';
export const ARTICLE_VIEW_MODAL_SET= 'ARTICLE_VIEW_MODAL_SET';
export const ARTICLE_HEADER= 'ARTICLE_HEADER';
export const ARTICLE_VIEW_TAB_SET= 'ARTICLE_VIEW_TAB_SET';
export const ARTICLE_SEARCH_CHANGE= 'ARTICLE_SEARCH_CHANGE';
export const ARTICLE_DETAIL = 'ARTICLE_DETAIL';
export const ARTICLE_DETAIL_SUCCESS = 'ARTICLE_DETAIL_SUCCESS';
export const ARTICLE_DETAIL_ERROR = 'ARTICLE_DETAIL_ERROR';
export const ARTICLE_SEARCH_PROJECT_LIST = 'ARTICLE_SEARCH_PROJECT_LIST';
export const ARTICLE_SEARCH_PROJECT_LIST_SUCCESS = 'ARTICLE_SEARCH_PROJECT_LIST_SUCCESS';
export const ARTICLE_SEARCH_PROJECT_LIST_ERROR = 'ARTICLE_SEARCH_PROJECT_LIST_ERROR';
export const ARTICLE_SEARCH_YEAR_LIST = 'ARTICLE_SEARCH_YEAR_LIST';
export const ARTICLE_SEARCH_YEAR_LIST_SUCCESS = 'ARTICLE_SEARCH_YEAR_LIST_SUCCESS';
export const ARTICLE_SEARCH_YEAR_LIST_ERROR = 'ARTICLE_SEARCH_YEAR_LIST_ERROR';
export const ARTICLE_SEARCH_ARTICLE_TYPE_LIST = 'ARTICLE_SEARCH_ARTICLE_TYPE_LIST';
export const ARTICLE_SEARCH_ARTICLE_TYPE_LIST_SUCCESS = 'ARTICLE_SEARCH_ARTICLE_TYPE_LIST_SUCCESS';
export const ARTICLE_SEARCH_ARTICLE_TYPE_LIST_ERROR = 'ARTICLE_SEARCH_ARTICLE_TYPE_LIST_ERROR';
export const ARTICLE_SEARCH_DEMAND_LIST = 'ARTICLE_SEARCH_DEMAND_LIST';
export const ARTICLE_SEARCH_DEMAND_LIST_SUCCESS = 'ARTICLE_SEARCH_DEMAND_LIST_SUCCESS';
export const ARTICLE_SEARCH_DEMAND_LIST_ERROR = 'ARTICLE_SEARCH_DEMAND_LIST_ERROR';

/* SEARCH */
export const SEARCH_GEO_COUNTRY = 'SEARCH_GEO_COUNTRY';
export const SEARCH_GEO_COUNTRY_SUCCESS = 'SEARCH_GEO_COUNTRY_SUCCESS';
export const SEARCH_GEO_COUNTRY_ERROR = 'SEARCH_GEO_COUNTRY_ERROR';
export const SEARCH_ARTICLE_GROUP = 'SEARCH_ARTICLE_GROUP';
export const SEARCH_ARTICLE_GROUP_SUCCESS = 'SEARCH_ARTICLE_GROUP_SUCCESS';
export const SEARCH_ARTICLE_GROUP_ERROR = 'SEARCH_ARTICLE_GROUP_ERROR';
export const SEARCH_CURRENCY = 'SEARCH_CURRENCY';
export const SEARCH_CURRENCY_SUCCESS = 'SEARCH_CURRENCY_SUCCESS';
export const SEARCH_CURRENCY_ERROR = 'SEARCH_CURRENCY_ERROR';
export const SEARCH_PROJECT = 'SEARCH_PROJECT';
export const SEARCH_PROJECT_SUCCESS = 'SEARCH_PROJECT_SUCCESS';
export const SEARCH_PROJECT_ERROR = 'SEARCH_PROJECT_ERROR';
export const SEARCH_ARTICLE_TYPE = 'SEARCH_ARTICLE_TYPE';
export const SEARCH_ARTICLE_TYPE_SUCCESS = 'SEARCH_ARTICLE_TYPE_SUCCESS';
export const SEARCH_ARTICLE_TYPE_ERROR = 'SEARCH_ARTICLE_TYPE_ERROR';
export const SEARCH_ARTICLE = 'SEARCH_ARTICLE';
export const SEARCH_ARTICLE_SUCCESS = 'SEARCH_ARTICLE_SUCCESS';
export const SEARCH_ARTICLE_ERROR = 'SEARCH_ARTICLE_ERROR';
export const SEARCH_SUPPLIER = 'SEARCH_SUPPLIER';
export const SEARCH_SUPPLIER_SUCCESS = 'SEARCH_SUPPLIER_SUCCESS';
export const SEARCH_SUPPLIER_ERROR = 'SEARCH_SUPPLIER_ERROR';
export const SEARCH_ACQUISITION = 'SEARCH_ACQUISITION';
export const SEARCH_ACQUISITION_SUCCESS = 'SEARCH_ACQUISITION_SUCCESS';
export const SEARCH_ACQUISITION_ERROR = 'SEARCH_ACQUISITION_ERROR';
export const SEARCH_DEMAND = 'SEARCH_DEMAND';
export const SEARCH_DEMAND_SUCCESS = 'SEARCH_DEMAND_SUCCESS';
export const SEARCH_DEMAND_ERROR = 'SEARCH_DEMAND_ERROR';

/* DEMAND */
export const DEMAND_LIST = 'DEMAND_LIST';
export const DEMAND_LIST_SUCCESS = 'DEMAND_LIST_SUCCESS';
export const DEMAND_LIST_ERROR = 'DEMAND_LIST_ERROR';
export const DEMAND_SEARCH_SET= 'DEMAND_SEARCH_SET';
export const DEMAND_PAGE_SET= 'DEMAND_PAGE_SET';
export const DEMAND_VIEW_MODAL_SET= 'DEMAND_VIEW_MODAL_SET';
export const DEMAND_HEADER= 'DEMAND_HEADER';
export const DEMAND_VIEW_TAB_SET= 'DEMAND_VIEW_TAB_SET';
export const DEMAND_SEARCH_CHANGE= 'DEMAND_SEARCH_CHANGE';
export const DEMAND_DETAIL = 'DEMAND_DETAIL';
export const DEMAND_DETAIL_SUCCESS = 'DEMAND_DETAIL_SUCCESS';
export const DEMAND_DETAIL_ERROR = 'DEMAND_DETAIL_ERROR';
export const DEMAND_SEARCH_PROJECT_LIST = 'DEMAND_SEARCH_PROJECT_LIST';
export const DEMAND_SEARCH_PROJECT_LIST_SUCCESS = 'DEMAND_SEARCH_PROJECT_LIST_SUCCESS';
export const DEMAND_SEARCH_PROJECT_LIST_ERROR = 'DEMAND_SEARCH_PROJECT_LIST_ERROR';

/* ACQUISITION */
export const ACQUISITION_LIST = 'ACQUISITION_LIST';
export const ACQUISITION_LIST_SUCCESS = 'ACQUISITION_LIST_SUCCESS';
export const ACQUISITION_LIST_ERROR = 'ACQUISITION_LIST_ERROR';
export const ACQUISITION_SEARCH_ARTICLE_TYPE_LIST = 'ACQUISITION_SEARCH_ARTICLE_TYPE_LIST';
export const ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_SUCCESS = 'ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_SUCCESS';
export const ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_ERROR = 'ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_ERROR';
export const ACQUISITION_SEARCH_SET= 'ACQUISITION_SEARCH_SET';
export const ACQUISITION_PAGE_SET= 'ACQUISITION_PAGE_SET';
export const ACQUISITION_VIEW_MODAL_SET= 'ACQUISITION_VIEW_MODAL_SET';
export const ACQUISITION_HEADER= 'ACQUISITION_HEADER';
export const ACQUISITION_VIEW_TAB_SET= 'ACQUISITION_VIEW_TAB_SET';
export const ACQUISITION_SEARCH_CHANGE= 'ACQUISITION_SEARCH_CHANGE';
export const ACQUISITION_DETAIL = 'ACQUISITION_DETAIL';
export const ACQUISITION_DETAIL_SUCCESS = 'ACQUISITION_DETAIL_SUCCESS';
export const ACQUISITION_DETAIL_ERROR = 'ACQUISITION_DETAIL_ERROR';
export const ACQUISITION_SEARCH_PROJECT_LIST = 'ACQUISITION_SEARCH_PROJECT_LIST';
export const ACQUISITION_SEARCH_PROJECT_LIST_SUCCESS = 'ACQUISITION_SEARCH_PROJECT_LIST_SUCCESS';
export const ACQUISITION_SEARCH_PROJECT_LIST_ERROR = 'ACQUISITION_SEARCH_PROJECT_LIST_ERROR';
export const ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST = 'ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST';
export const ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_SUCCESS = 'ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_SUCCESS';
export const ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_ERROR = 'ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_ERROR';
export const ACQUISITION_SEARCH_DEMAND_LIST = 'ACQUISITION_SEARCH_DEMAND_LIST';
export const ACQUISITION_SEARCH_DEMAND_LIST_SUCCESS = 'ACQUISITION_SEARCH_DEMAND_LIST_SUCCESS';
export const ACQUISITION_SEARCH_DEMAND_LIST_ERROR = 'ACQUISITION_SEARCH_DEMAND_LIST_ERROR';

/* SUPPLIER */
export const SUPPLIER_LIST = 'SUPPLIER_LIST';
export const SUPPLIER_LIST_SUCCESS = 'SUPPLIER_LIST_SUCCESS';
export const SUPPLIER_LIST_ERROR = 'SUPPLIER_LIST_ERROR';
export const SUPPLIER_SEARCH_GEO_COUNTRY_LIST = 'SUPPLIER_SEARCH_GEO_COUNTRY_LIST';
export const SUPPLIER_SEARCH_GEO_COUNTRY_LIST_SUCCESS = 'SUPPLIER_SEARCH_GEO_COUNTRY_LIST_SUCCESS';
export const SUPPLIER_SEARCH_GEO_COUNTRY_LIST_ERROR = 'SUPPLIER_SEARCH_GEO_COUNTRY_LIST_ERROR';
export const SUPPLIER_SEARCH_SET= 'SUPPLIER_SEARCH_SET';
export const SUPPLIER_PAGE_SET= 'SUPPLIER_PAGE_SET';
export const SUPPLIER_VIEW_MODAL_SET= 'SUPPLIER_VIEW_MODAL_SET';
export const SUPPLIER_HEADER= 'SUPPLIER_HEADER';
export const SUPPLIER_VIEW_TAB_SET= 'SUPPLIER_VIEW_TAB_SET';
export const SUPPLIER_SEARCH_CHANGE= 'SUPPLIER_SEARCH_CHANGE';
export const SUPPLIER_DETAIL = 'SUPPLIER_DETAIL';
export const SUPPLIER_DETAIL_SUCCESS = 'SUPPLIER_DETAIL_SUCCESS';
export const SUPPLIER_DETAIL_ERROR = 'SUPPLIER_DETAIL_ERROR';


/* ACQUISITION_DETAIL */
export const ACQUISITION_DETAIL_LIST = 'ACQUISITION_DETAIL_LIST';
export const ACQUISITION_DETAIL_LIST_SUCCESS = 'ACQUISITION_DETAIL_LIST_SUCCESS';
export const ACQUISITION_DETAIL_LIST_ERROR = 'ACQUISITION_DETAIL_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST = 'ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST';
export const ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_SET= 'ACQUISITION_DETAIL_SEARCH_SET';
export const ACQUISITION_DETAIL_PAGE_SET= 'ACQUISITION_DETAIL_PAGE_SET';
export const ACQUISITION_DETAIL_VIEW_MODAL_SET= 'ACQUISITION_DETAIL_VIEW_MODAL_SET';
export const ACQUISITION_DETAIL_HEADER= 'ACQUISITION_DETAIL_HEADER';
export const ACQUISITION_DETAIL_VIEW_TAB_SET= 'ACQUISITION_DETAIL_VIEW_TAB_SET';
export const ACQUISITION_DETAIL_SEARCH_CHANGE= 'ACQUISITION_DETAIL_SEARCH_CHANGE';
export const ACQUISITION_DETAIL_DETAIL = 'ACQUISITION_DETAIL_DETAIL';
export const ACQUISITION_DETAIL_DETAIL_SUCCESS = 'ACQUISITION_DETAIL_DETAIL_SUCCESS';
export const ACQUISITION_DETAIL_DETAIL_ERROR = 'ACQUISITION_DETAIL_DETAIL_ERROR';
export const ACQUISITION_DETAIL_SEARCH_PROJECT_LIST = 'ACQUISITION_DETAIL_SEARCH_PROJECT_LIST';
export const ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_YEAR_LIST = 'ACQUISITION_DETAIL_SEARCH_YEAR_LIST';
export const ACQUISITION_DETAIL_SEARCH_YEAR_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_YEAR_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_YEAR_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_YEAR_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_ERROR';
export const ACQUISITION_DETAIL_SEARCH_DEMAND_LIST = 'ACQUISITION_DETAIL_SEARCH_DEMAND_LIST';
export const ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_SUCCESS = 'ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_SUCCESS';
export const ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_ERROR = 'ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_ERROR';

/* CODE22 */
export const CODE22_LIST = 'CODE22_LIST';
export const CODE22_LIST_SUCCESS = 'CODE22_LIST_SUCCESS';
export const CODE22_LIST_ERROR = 'CODE22_LIST_ERROR';
export const CODE22_SEARCH_DISPENSING_UNIT_LIST = 'CODE22_SEARCH_DISPENSING_UNIT_LIST';
export const CODE22_SEARCH_DISPENSING_UNIT_LIST_SUCCESS = 'CODE22_SEARCH_DISPENSING_UNIT_LIST_SUCCESS';
export const CODE22_SEARCH_DISPENSING_UNIT_LIST_ERROR = 'CODE22_SEARCH_DISPENSING_UNIT_LIST_ERROR';
export const CODE22_SEARCH_SET= 'CODE22_SEARCH_SET';
export const CODE22_PAGE_SET= 'CODE22_PAGE_SET';
export const CODE22_VIEW_MODAL_SET= 'CODE22_VIEW_MODAL_SET';
export const CODE22_HEADER= 'CODE22_HEADER';
export const CODE22_VIEW_TAB_SET= 'CODE22_VIEW_TAB_SET';
export const CODE22_SEARCH_CHANGE= 'CODE22_SEARCH_CHANGE';
export const CODE22_DETAIL = 'CODE22_DETAIL';
export const CODE22_DETAIL_SUCCESS = 'CODE22_DETAIL_SUCCESS';
export const CODE22_DETAIL_ERROR = 'CODE22_DETAIL_ERROR';
export const CODE22_SEARCH_ATC5_LIST = 'CODE22_SEARCH_ATC5_LIST';
export const CODE22_SEARCH_ATC5_LIST_SUCCESS = 'CODE22_SEARCH_ATC5LIST_SUCCESS';
export const CODE22_SEARCH_ATC5_LIST_ERROR = 'CODE22_SEARCH_ATC5_LIST_ERROR';
export const CODE22_SEARCH_YEAR_LIST = 'CODE22_SEARCH_YEAR_LIST';
export const CODE22_SEARCH_YEAR_LIST_SUCCESS = 'CODE22_SEARCH_YEAR_LIST_SUCCESS';
export const CODE22_SEARCH_YEAR_LIST_ERROR = 'CODE22_SEARCH_YEAR_LIST_ERROR';
export const CODE22_SEARCH_CODE22_TYPE_LIST = 'CODE22_SEARCH_CODE22_TYPE_LIST';
export const CODE22_SEARCH_CODE22_TYPE_LIST_SUCCESS = 'CODE22_SEARCH_CODE22_TYPE_LIST_SUCCESS';
export const CODE22_SEARCH_CODE22_TYPE_LIST_ERROR = 'CODE22_SEARCH_CODE22_TYPE_LIST_ERROR';
export const CODE22_SEARCH_DEMAND_LIST = 'CODE22_SEARCH_DEMAND_LIST';
export const CODE22_SEARCH_DEMAND_LIST_SUCCESS = 'CODE22_SEARCH_DEMAND_LIST_SUCCESS';
export const CODE22_SEARCH_DEMAND_LIST_ERROR = 'CODE22_SEARCH_DEMAND_LIST_ERROR';

/* CODE22_REVIEW */
export const CODE22_REVIEW_LIST = 'CODE22_REVIEW_LIST';
export const CODE22_REVIEW_LIST_SUCCESS = 'CODE22_REVIEW_LIST_SUCCESS';
export const CODE22_REVIEW_LIST_ERROR = 'CODE22_REVIEW_LIST_ERROR';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_SUCCESS = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_SUCCESS';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_ERROR = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_ERROR';
export const CODE22_REVIEW_SEARCH_SET= 'CODE22_REVIEW_SEARCH_SET';
export const CODE22_REVIEW_PAGE_SET= 'CODE22_REVIEW_PAGE_SET';
export const CODE22_REVIEW_VIEW_MODAL_SET= 'CODE22_REVIEW_VIEW_MODAL_SET';
export const CODE22_REVIEW_HEADER= 'CODE22_REVIEW_HEADER';
export const CODE22_REVIEW_VIEW_TAB_SET= 'CODE22_REVIEW_VIEW_TAB_SET';
export const CODE22_REVIEW_SEARCH_CHANGE= 'CODE22_REVIEW_SEARCH_CHANGE';
export const CODE22_REVIEW_DETAIL = 'CODE22_REVIEW_DETAIL';
export const CODE22_REVIEW_DETAIL_SUCCESS = 'CODE22_REVIEW_DETAIL_SUCCESS';
export const CODE22_REVIEW_DETAIL_ERROR = 'CODE22_REVIEW_DETAIL_ERROR';
export const CODE22_REVIEW_SEARCH_PROJECT_LIST = 'CODE22_REVIEW_SEARCH_PROJECT_LIST';
export const CODE22_REVIEW_SEARCH_PROJECT_LIST_SUCCESS = 'CODE22_REVIEW_SEARCH_PROJECT_LIST_SUCCESS';
export const CODE22_REVIEW_SEARCH_PROJECT_LIST_ERROR = 'CODE22_REVIEW_SEARCH_PROJECT_LIST_ERROR';
export const CODE22_REVIEW_SEARCH_YEAR_LIST = 'CODE22_REVIEW_SEARCH_YEAR_LIST';
export const CODE22_REVIEW_SEARCH_YEAR_LIST_SUCCESS = 'CODE22_REVIEW_SEARCH_YEAR_LIST_SUCCESS';
export const CODE22_REVIEW_SEARCH_YEAR_LIST_ERROR = 'CODE22_REVIEW_SEARCH_YEAR_LIST_ERROR';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_SUCCESS = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_SUCCESS';
export const CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_ERROR = 'CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_ERROR';
export const CODE22_REVIEW_SEARCH_DEMAND_LIST = 'CODE22_REVIEW_SEARCH_DEMAND_LIST';
export const CODE22_REVIEW_SEARCH_DEMAND_LIST_SUCCESS = 'CODE22_REVIEW_SEARCH_DEMAND_LIST_SUCCESS';
export const CODE22_REVIEW_SEARCH_DEMAND_LIST_ERROR = 'CODE22_REVIEW_SEARCH_DEMAND_LIST_ERROR';

/* DASHBOARD */
export const DASHBOARD_LIST = 'DASHBOARD_LIST';
export const DASHBOARD_LIST_SUCCESS = 'DASHBOARD_LIST_SUCCESS';
export const DASHBOARD_LIST_ERROR = 'DASHBOARD_LIST_ERROR';


/*KPI MATRIX*/
export const KPI_MATRIX_LIST = 'KPI_MATRIX_LIST';
export const KPI_MATRIX_LIST_SUCCESS = 'KPI_MATRIX_LIST_SUCCESS';
export const KPI_MATRIX_LIST_ERROR = 'KPI_MATRIX_LIST_ERROR';
export const KPI_MATRIX_LIST_ITB = 'KPI_MATRIX_LIST_ITB';
export const KPI_MATRIX_LIST_ITB_SUCCESS = 'KPI_MATRIX_LIST_ITB_SUCCESS';
export const KPI_MATRIX_LIST_ITB_ERROR = 'KPI_MATRIX_LIST_ITB_ERROR';
export const KPI_MATRIX_LIST_ANUAL_BASE_LINE = 'KPI_MATRIX_LIST_ANUAL_BASE_LINE';
export const KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS = 'KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS';
export const KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR = 'KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR';
export const KPI_MATRIX_VIEW_MODAL_SET = 'KPI_MATRIX_VIEW_MODAL_SET';
export const KPI_MATRIX_DETAIL = 'KPI_MATRIX_DETAIL';
export const KPI_MATRIX_DETAIL_SUCCESS = 'KPI_MATRIX_DETAIL_SUCCESS';
export const KPI_MATRIX_DETAIL_ERROR = 'KPI_MATRIX_DETAIL_ERROR';
export const KPI_MATRIX_DATA_LIST = 'KPI_MATRIX_DATA_LIST';
export const KPI_MATRIX_DATA_LIST_SUCCESS = 'KPI_MATRIX_DATA_LIST_SUCCESS';
export const KPI_MATRIX_DATA_LIST_ERROR = 'KPI_MATRIX_DATA_LIST_ERROR';
export const KPI_MATRIX_TAB_SET = 'KPI_MATRIX_TAB_SET';
export const KPI_MATRIX_GRAPH_3MORE_LIST = 'KPI_MATRIX_GRAPH_3MORE_LIST';
export const KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS = 'KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS';
export const KPI_MATRIX_GRAPH_3MORE_LIST_ERROR = 'KPI_MATRIX_GRAPH_3MORE_LIST_ERROR';
export const KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST = 'KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST';
export const KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS = 'KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS';
export const KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR = 'KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR';
export const KPI_MATRIX_GRAPH_PIE_LIST = 'KPI_MATRIX_GRAPH_PIE_LIST';
export const KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS = 'KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS';
export const KPI_MATRIX_GRAPH_PIE_LIST_ERROR = 'KPI_MATRIX_GRAPH_PIE_LIST_ERROR';
export const KPI_MATRIX_GRAPH_BAR_LIST = 'KPI_MATRIX_GRAPH_BAR_LIST';
export const KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS = 'KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS';
export const KPI_MATRIX_GRAPH_BAR_LIST_ERROR = 'KPI_MATRIX_GRAPH_BAR_LIST_ERROR';
export const KPI_MATRIX_TAG_SAVINGS_LIST = 'KPI_MATRIX_TAG_SAVINGS_LIST';
export const KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS = 'KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS';
export const KPI_MATRIX_TAG_SAVINGS_LIST_ERROR = 'KPI_MATRIX_TAG_SAVINGS_LIST_ERROR';
export const KPI_MATRIX_TOTAL_PZS_LIST = 'KPI_MATRIX_TOTAL_PZS_LIST';
export const KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS = 'KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS';
export const KPI_MATRIX_TOTAL_PZS_LIST_ERROR = 'KPI_MATRIX_TOTAL_PZS_LIST_ERROR';
export const KPI_MATRIX_BIDDER_LIST = 'KPI_MATRIX_BIDDER_LIST';
export const KPI_MATRIX_BIDDER_LIST_SUCCESS = 'KPI_MATRIX_BIDDER_LIST_SUCCESS';
export const KPI_MATRIX_BIDDER_LIST_ERROR = 'KPI_MATRIX_BIDDER_LIST_ERROR';
export const KPI_MATRIX_BIDDERMC_LIST = 'KPI_MATRIX_BIDDERMC_LIST';
export const KPI_MATRIX_BIDDERMC_LIST_SUCCESS = 'KPI_MATRIX_BIDDERMC_LIST_SUCCESS';
export const KPI_MATRIX_BIDDERMC_LIST_ERROR = 'KPI_MATRIX_BIDDERMC_LIST_ERROR';
export const KPI_MATRIX_BIDDERMED2021_LIST = 'KPI_MATRIX_BIDDERMED2021_LIST';
export const KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS = 'KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS';
export const KPI_MATRIX_BIDDERMED2021_LIST_ERROR = 'KPI_MATRIX_BIDDERMED2021_LIST_ERROR';
export const KPI_MATRIX_BIDDERMC2021_LIST = 'KPI_MATRIX_BIDDERMC2021_LIST';
export const KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS = 'KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS';
export const KPI_MATRIX_BIDDERMC2021_LIST_ERROR = 'KPI_MATRIX_BIDDERMC2021_LIST_ERROR';
export const KPI_FUNNEL_LIST = 'KPI_FUNNEL_LIST';
export const KPI_FUNNEL_LIST_SUCCESS = 'KPI_FUNNEL_LIST_SUCCESS';
export const KPI_FUNNEL_LIST_ERROR = 'KPI_FUNNEL_LIST_ERROR';
export const KPI_FUNNELMC_LIST = 'KPI_FUNNELMC_LIST';
export const KPI_FUNNELMC_LIST_SUCCESS = 'KPI_FUNNELMC_LIST_SUCCESS';
export const KPI_FUNNELMC_LIST_ERROR = 'KPI_FUNNELMC_LIST_ERROR';

export const KPI_EVALUATIONS = 'KPI_EVALUATIONS';
export const KPI_EVALUATIONS_SUCCESS = 'KPI_EVALUATIONS_SUCCESS';
export const KPI_EVALUATIONS_ERROR = 'KPI_EVALUATIONS_ERROR';
export const KPI_EVALUATIONS_SEARCH_SET = 'KPI_EVALUATIONS_SEARCH_SET';
export const KPI_EVALUATIONS_SEARCH_CHANGE = 'KPI_EVALUATIONS_SEARCH_CHANGE';
export const KPI_EVALUATIONS_TAB_SET = 'KPI_EVALUATIONS_TAB_SET';
export const KPI_FUNNEL_PROCCESS_LIST = 'KPI_FUNNEL_PROCCESS_LIST';
export const KPI_FUNNEL_PROCCESS_LIST_SUCCESS = 'KPI_FUNNEL_PROCCESS_LIST_SUCCESS';
export const KPI_FUNNEL_PROCCESS_LIST_ERROR = 'KPI_FUNNEL_PROCCESS_LIST_ERROR';

/*SNAPSHOT*/
export const COUNTRY_DETAIL = 'COUNTRY_DETAIL';
export const COUNTRY_DETAIL_SUCCESS = 'COUNTRY_DETAIL_SUCCESS';
export const COUNTRY_DETAIL_ERROR = 'COUNTRY_DETAIL_ERROR';

/*ORP PRICE*/
export const ORP_PRICE_SEARCH_SET = 'ORP_PRICE_SEARCH_SET';
export const ORP_PRICE_SEARCH_CHANGE = 'ORP_PRICE_SEARCH_CHANGE';
export const ACTIVE_INGREDIENT_CODE20 = 'ACTIVE_INGREDIENT_CODE20';
export const ACTIVE_INGREDIENT_CODE20_SUCCESS = 'ACTIVE_INGREDIENT_CODE20_SUCCESS';
export const ACTIVE_INGREDIENT_CODE20_ERROR = 'ACTIVE_INGREDIENT_CODE20_ERROR';
export const DOSAGE_FORM_CODE20 = 'DOSAGE_FORM_CODE20';
export const DOSAGE_FORM_CODE20_SUCCESS = 'DOSAGE_FORM_CODE20_SUCCESS';
export const DOSAGE_FORM_CODE20_ERROR = 'DOSAGE_FORM_CODE20_ERROR';
export const MED_DESCRIPTION_CODE20 = 'MED_DESCRIPTION_CODE20';
export const MED_DESCRIPTION_CODE20_SUCCESS = 'MED_DESCRIPTION_CODE20_SUCCESS';
export const MED_DESCRIPTION_CODE20_ERROR = 'MED_DESCRIPTION_CODE20_ERROR';
export const ORP_PRICE_GRAPH = 'ORP_PRICE_GRAPH';
export const ORP_PRICE_GRAPH_SUCCESS = 'ORP_PRICE_GRAPH_SUCCESS';
export const ORP_PRICE_GRAPH_ERROR = 'ORP_PRICE_GRAPH_ERROR';
export const ORP_COMPRAS_UNOPS = 'ORP_COMPRAS_UNOPS';
export const ORP_COMPRAS_UNOPS_SUCCESS = 'ORP_COMPRAS_UNOPS_SUCCESS';
export const ORP_COMPRAS_UNOPS_ERROR = 'ORP_COMPRAS_UNOPS_ERROR';
export const ORP_COMPRAS_UNOPS_SET = 'ORP_COMPRAS_UNOPS_SET';
export const ORP_COMPRAS_UNOPS_PAGE_SET = 'ORP_COMPRAS_UNOPS_PAGE_SET';
export const ORP_COMPRAS_UNOPS_SEARCH_CHANGE = 'ORP_COMPRAS_UNOPS_SEARCH_CHANGE';

/* EXTERNAL_REVIEW */
export const EXTERNAL_REVIEW_DETAIL = 'EXTERNAL_REVIEW_DETAIL';
export const EXTERNAL_REVIEW_DETAIL_SUCCESS = 'EXTERNAL_REVIEW_DETAIL_SUCCESS';
export const EXTERNAL_REVIEW_DETAIL_ERROR = 'EXTERNAL_REVIEW_DETAIL_ERROR';
export const EXTERNAL_REVIEW_ADD_SET = 'EXTERNAL_REVIEW_ADD_SET';
export const EXTERNAL_REVIEW_ADD_CHANGE = 'EXTERNAL_REVIEW_ADD_CHANGE';
export const EXTERNAL_REVIEW_EDIT_MODAL_SET = 'EXTERNAL_REVIEW_EDIT_MODAL_SET';
export const EXTERNAL_REVIEW_EDIT_TAB_SET = 'EXTERNAL_REVIEW_EDIT_TAB_SET';
export const EXTERNAL_REVIEW_SEARCH = 'EXTERNAL_REVIEW_SEARCH';
export const EXTERNAL_REVIEW_SEARCH_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_ERROR = 'EXTERNAL_REVIEW_SEARCH_ERROR';
export const EXTERNAL_REVIEW_ADD = 'EXTERNAL_REVIEW_ADD';
export const EXTERNAL_REVIEW_ADD_SUCCESS = 'EXTERNAL_REVIEW_ADD_SUCCESS';
export const EXTERNAL_REVIEW_ADD_ERROR = 'EXTERNAL_REVIEW_ADD_ERROR';
export const EXTERNAL_REVIEW_ADD_MODAL_SET = 'EXTERNAL_REVIEW_ADD_MODAL_SET';
export const EXTERNAL_REVIEW_HEADER = 'EXTERNAL_REVIEW_HEADER';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR';
export const EXTERNAL_REVIEW_LIST = 'EXTERNAL_REVIEW_LIST';
export const EXTERNAL_REVIEW_LIST_SUCCESS = 'EXTERNAL_REVIEW_LIST_SUCCESS';
export const EXTERNAL_REVIEW_LIST_ERROR = 'EXTERNAL_REVIEW_LIST_ERROR';
export const EXTERNAL_REVIEW_SEARCH_SET = 'EXTERNAL_REVIEW_SEARCH_SET';
export const EXTERNAL_REVIEW_SEARCH_CHANGE = 'EXTERNAL_REVIEW_SEARCH_CHANGE';
export const EXTERNAL_REVIEW_PAGE_SET = 'EXTERNAL_REVIEW_PAGE_SET';
export const EXTERNAL_REVIEW_VIEW_MODAL_SET = 'EXTERNAL_REVIEW_VIEW_MODAL_SET';
export const EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET = 'EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET';
export const EXTERNAL_REVIEW_VIEW_SET = 'EXTERNAL_REVIEW_VIEW_SET';
export const EXTERNAL_REVIEW_VIEW_TAB_SET = 'EXTERNAL_REVIEW_VIEW_TAB_SET';
export const EXTERNAL_REVIEW_EDIT_CHANGE = 'EXTERNAL_REVIEW_EDIT_CHANGE';
export const EXTERNAL_REVIEW_UPDATE = 'EXTERNAL_REVIEW_UPDATE';
export const EXTERNAL_REVIEW_UPDATE_SUCCESS = 'EXTERNAL_REVIEW_UPDATE_SUCCESS';
export const EXTERNAL_REVIEW_UPDATE_ERROR = 'EXTERNAL_REVIEW_UPDATE_ERROR';

/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';

/*ADMIN USER*/
export const ADMIN_USER_LIST = 'ADMIN_USER_LIST';
export const ADMIN_USER_LIST_SUCCESS = 'ADMIN_USER_LIST_SUCCESS';
export const ADMIN_USER_LIST_ERROR = 'ADMIN_USER_LIST_ERROR';
export const ADMIN_USER_PAGE_SET = 'ADMIN_USER_PAGE_SET';
export const ADMIN_USER_HEADER = 'ADMIN_USER_HEADER';
export const ADMIN_USER_SEARCH_SET = 'ADMIN_USER_SEARCH_SET';
export const ADMIN_USER_SEARCH_CHANGE = 'ADMIN_USER_SEARCH_CHANGE';
export const ADMIN_USER_ADD_SET = 'ADMIN_USER_ADD_SET';
export const ADMIN_USER_ADD_MODAL_SET = 'ADMIN_USER_ADD_MODAL_SET';
export const ADMIN_USER_ADD = 'ADMIN_USER_ADD';
export const ADMIN_USER_ADD_SUCCESS = 'ADMIN_USER_ADD_SUCCESS';
export const ADMIN_USER_ADD_ERROR = 'ADMIN_USER_ADD_ERROR';
export const ADMIN_USER_ADD_CHANGE = 'ADMIN_USER_ADD_CHANGE';
export const ADMIN_USER_EDIT_SET = 'ADMIN_USER_EDIT_SET';
export const ADMIN_USER_EDIT_CHANGE = 'ADMIN_USER_EDIT_CHANGE';
export const ADMIN_USER_EDIT_MODAL_SET = 'ADMIN_USER_EDIT_MODAL_SET';
export const ADMIN_USER_DETAIL = 'ADMIN_USER_DETAIL';
export const ADMIN_USER_DETAIL_SUCCESS = 'ADMIN_USER_DETAIL_SUCCESS';
export const ADMIN_USER_DETAIL_ERROR = 'ADMIN_USER_DETAIL_ERROR';
export const ADMIN_USER_UPDATE = 'ADMIN_USER_UPDATE';
export const ADMIN_USER_UPDATE_SUCCESS = 'ADMIN_USER_UPDATE_SUCCESS';
export const ADMIN_USER_UPDATE_ERROR = 'ADMIN_USER_UPDATE_ERROR';
export const ADMIN_USER_DETAIL_ACCESS = 'ADMIN_USER_DETAIL_ACCESS';
export const ADMIN_USER_DETAIL_ACCESS_SUCCESS = 'ADMIN_USER_DETAIL_ACCESS_SUCCESS';
export const ADMIN_USER_DETAIL_ACCESS_ERROR = 'ADMIN_USER_DETAIL_ACCESS_ERROR';
export const ADMIN_USER_DETAIL_ACCESS_MODAL_SET = 'ADMIN_USER_DETAIL_ACCESS_MODAL_SET';

/*FORM KPI LRC*/
export const FORM_KPI_LCR_LIST = 'FORM_KPI_LCR_LIST';
export const FORM_KPI_LCR_LIST_SUCCESS = 'FORM_KPI_LCR_LIST_SUCCESS';
export const FORM_KPI_LCR_LIST_ERROR = 'FORM_KPI_LCR_LIST_ERROR';
export const FORM_KPI_LCR_PAGE_SET = 'FORM_KPI_LCR_PAGE_SET';
export const FORM_KPI_LCR_SEARCH_SET = 'FORM_KPI_LCR_SEARCH_SET';
export const FORM_KPI_LCR_SEARCH_CHANGE = 'FORM_KPI_LCR_SEARCH_CHANGE';
export const FORM_KPI_LCR_ADD_MODAL_SET = 'FORM_KPI_LCR_ADD_MODAL_SET';
export const FORM_KPI_LCR_ADD = 'FORM_KPI_LCR_ADD';
export const FORM_KPI_LCR_ADD_SUCCESS = 'FORM_KPI_LCR_ADD_SUCCESS';
export const FORM_KPI_LCR_ADD_ERROR = 'FORM_KPI_LCR_ADD_ERROR';
export const FORM_KPI_LCR_ADD_CHANGE = 'FORM_KPI_LCR_ADD_CHANGE';
export const FORM_KPI_LCR_ADD_SET = 'FORM_KPI_LCR_ADD_SET';
export const FORM_KPI_LCR_PROJECT = 'FORM_KPI_LCR_PROJECT';
export const FORM_KPI_LCR_PROJECT_SUCCESS = 'FORM_KPI_LCR_PROJECT_SUCCESS';
export const FORM_KPI_LCR_PROJECT_ERROR = 'FORM_KPI_LCR_PROJECT_ERROR';
export const FORM_KPI_LCR_ARTICLE_TYPE = 'FORM_KPI_LCR_ARTICLE_TYPE';
export const FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS = 'FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS';
export const FORM_KPI_LCR_ARTICLE_TYPE_ERROR = 'FORM_KPI_LCR_ARTICLE_TYPE_ERROR';
export const FORM_KPI_LCR_ACQUISITION_TYPE = 'FORM_KPI_LCR_ACQUISITION_TYPE';
export const FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS = 'FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS';
export const FORM_KPI_LCR_ACQUISITION_TYPE_ERROR = 'FORM_KPI_LCR_ACQUISITION_TYPE_ERROR';
export const FORM_KPI_LCR_CONTRACT_TYPE = 'FORM_KPI_LCR_CONTRACT_TYPE';
export const FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS = 'FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS';
export const FORM_KPI_LCR_CONTRACT_TYPE_ERROR = 'FORM_KPI_LCR_CONTRACT_TYPE_ERROR';
export const FORM_KPI_LCR_COUNTRY_PROJECT = 'FORM_KPI_LCR_COUNTRY_PROJECT';
export const FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS = 'FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS';
export const FORM_KPI_LCR_COUNTRY_PROJECT_ERROR = 'FORM_KPI_LCR_COUNTRY_PROJECT_ERROR';
export const FORM_KPI_LCR_COUNTRY_LIST = 'FORM_KPI_LCR_COUNTRY_LIST';
export const FORM_KPI_LCR_COUNTRY_LIST_SUCCESS = 'FORM_KPI_LCR_COUNTRY_LIST_SUCCESS';
export const FORM_KPI_LCR_COUNTRY_LIST_ERROR = 'FORM_KPI_LCR_COUNTRY_LIST_ERROR';


/********************MARKETINTEL PRICE********************************************/
export const MARKETINTEL_PRICE_LIST = 'MARKETINTEL_PRICE_LIST';
export const MARKETINTEL_PRICE_LIST_SUCCESS = 'MARKETINTEL_PRICE_LIST_SUCCESS';
export const MARKETINTEL_PRICE_LIST_ERROR = 'MARKETINTEL_PRICE_LIST_ERROR';
export const MARKETINTEL_PRICE_PAGE_SET = 'MARKETINTEL_PRICE_PAGE_SET';
export const MARKETINTEL_PRICE_HEADER = 'MARKETINTEL_PRICE_HEADER';
export const MARKETINTEL_PRICE_SEARCH_SET = 'MARKETINTEL_PRICE_SEARCH_SET';
export const MARKETINTEL_PRICE_SEARCH_CHANGE = 'MARKETINTEL_PRICE_SEARCH_CHANGE';
export const MARKETINTEL_PRICE_VIEW_MODAL_SET = 'MARKETINTEL_OPENNING_PRICE_MODAL_SET';
export const MARKETINTEL_PRICE_VIEW_DATA_SET = 'MARKETINTEL_PRICE_VIEW_DATA_SET';

/********************MARKETINTEL BID********************************************/
export const MARKETINTEL_BID_LIST = 'MARKETINTEL_BID_LIST';
export const MARKETINTEL_BID_LIST_SUCCESS = 'MARKETINTEL_BID_LIST_SUCCESS';
export const MARKETINTEL_BID_LIST_ERROR = 'MARKETINTEL_BID_LIST_ERROR';
export const MARKETINTEL_BID_PAGE_SET = 'MARKETINTEL_BID_PAGE_SET';
export const MARKETINTEL_BID_HEADER = 'MARKETINTEL_BID_HEADER';
export const MARKETINTEL_BID_SEARCH_SET = 'MARKETINTEL_BID_SEARCH_SET';
export const MARKETINTEL_BID_SEARCH_CHANGE = 'MARKETINTEL_BID_SEARCH_CHANGE';
export const MARKETINTEL_BID_VIEW_MODAL_SET = 'MARKETINTEL_BID_VIEW_MODAL_SET';
export const MARKETINTEL_BID_VIEW_DATA_SET = 'MARKETINTEL_BID_VIEW_DATA_SET';

/********************MARKETINTEL ARTICLE********************************************/
export const MARKETINTEL_ARTICLE_LIST = 'MARKETINTEL_ARTICLE_LIST';
export const MARKETINTEL_ARTICLE_LIST_SUCCESS = 'MARKETINTEL_ARTICLE_LIST_SUCCESS';
export const MARKETINTEL_ARTICLE_LIST_ERROR = 'MARKETINTEL_ARTICLE_LIST_ERROR';
export const MARKETINTEL_ARTICLE_PAGE_SET = 'MARKETINTEL_ARTICLE_PAGE_SET';
export const MARKETINTEL_ARTICLE_HEADER = 'MARKETINTEL_ARTICLE_HEADER';
export const MARKETINTEL_ARTICLE_SEARCH_SET = 'MARKETINTEL_ARTICLE_SEARCH_SET';
export const MARKETINTEL_ARTICLE_SEARCH_CHANGE = 'MARKETINTEL_ARTICLE_SEARCH_CHANGE';
export const MARKETINTEL_ARTICLE_VIEW_MODAL_SET = 'MARKETINTEL_ARTICLE_VIEW_MODAL_SET';
export const MARKETINTEL_ARTICLE_VIEW_DATA_SET = 'MARKETINTEL_ARTICLE_VIEW_DATA_SET';

/********************MARKETINTEL SUPPLIER********************************************/
export const MARKETINTEL_SUPPLIER_LIST = 'MARKETINTEL_SUPPLIER_LIST';
export const MARKETINTEL_SUPPLIER_LIST_SUCCESS = 'MARKETINTEL_SUPPLIER_LIST_SUCCESS';
export const MARKETINTEL_SUPPLIER_LIST_ERROR = 'MARKETINTEL_SUPPLIER_LIST_ERROR';
export const MARKETINTEL_SUPPLIER_PAGE_SET = 'MARKETINTEL_SUPPLIER_PAGE_SET';
export const MARKETINTEL_SUPPLIER_HEADER = 'MARKETINTEL_SUPPLIER_HEADER';
export const MARKETINTEL_SUPPLIER_SEARCH_SET = 'MARKETINTEL_SUPPLIER_SEARCH_SET';
export const MARKETINTEL_SUPPLIER_SEARCH_CHANGE = 'MARKETINTEL_SUPPLIER_SEARCH_CHANGE';
export const MARKETINTEL_SUPPLIER_VIEW_MODAL_SET = 'MARKETINTEL_SUPPLIER_VIEW_MODAL_SET';
export const MARKETINTEL_SUPPLIER_VIEW_DATA_SET = 'MARKETINTEL_SUPPLIER_VIEW_DATA_SET';

/********************MARKETINTEL OPENNING********************************************/
export const MARKETINTEL_OPENNING_LIST = 'MARKETINTEL_OPENNING_LIST';
export const MARKETINTEL_OPENNING_LIST_SUCCESS = 'MARKETINTEL_OPENNING_LIST_SUCCESS';
export const MARKETINTEL_OPENNING_LIST_ERROR = 'MARKETINTEL_OPENNING_LIST_ERROR';
export const MARKETINTEL_OPENNING_PAGE_SET = 'MARKETINTEL_OPENNING_PAGE_SET';
export const MARKETINTEL_OPENNING_HEADER = 'MARKETINTEL_OPENNING_HEADER';
export const MARKETINTEL_OPENNING_SEARCH_SET = 'MARKETINTEL_OPENNING_SEARCH_SET';
export const MARKETINTEL_OPENNING_SEARCH_CHANGE = 'MARKETINTEL_OPENNING_SEARCH_CHANGE';
export const MARKETINTEL_OPENNING_VIEW_MODAL_SET = 'MARKETINTEL_OPENNING_VIEW_MODAL_SET';
export const MARKETINTEL_OPENNING_VIEW_DATA_SET = 'MARKETINTEL_OPENNING_VIEW_DATA_SET';
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID';
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_SUCCESS = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_SUCCESS';
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_ERROR = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_ERROR';
export const ORIGIN_BID_TAB_SET = "ORIGIN_BID_TAB_SET";
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER';
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_SUCCESS = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_SUCCESS';
export const MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_ERROR = 'MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_ERROR';
export const OPENNING_TAB_SET = "OPENNING_TAB_SET";
export const MARKETINTEL_OPENNING_TAB_AWARD = "MARKETINTEL_OPENNING_TAB_AWARD";
export const MARKETINTEL_OPENNING_TAB_AWARD_SUCCESS = "MARKETINTEL_OPENNING_TAB_AWARD_SUCCESS";
export const MARKETINTEL_OPENNING_TAB_AWARD_ERROR = "MARKETINTEL_OPENNING_TAB_AWARD_ERROR";

/****************PUBLICATION DOCUMENT*****************************************************/
export const PUBLICATION_DOCUMENT_LIST = 'PUBLICATION_DOCUMENT_LIST';
export const PUBLICATION_DOCUMENT_LIST_SUCCESS = 'PUBLICATION_DOCUMENT_LIST_SUCCESS';
export const PUBLICATION_DOCUMENT_LIST_ERROR = 'PUBLICATION_DOCUMENT_LIST_ERROR';
export const PUBLICATION_DOCUMENT_PAGE_SET = 'PUBLICATION_DOCUMENT_PAGE_SET';
export const PUBLICATION_DOCUMENT_HEADER = 'PUBLICATION_DOCUMENT_HEADER';
export const PUBLICATION_DOCUMENT_SEARCH_SET = 'PUBLICATION_DOCUMENT_SEARCH_SET';
export const PUBLICATION_DOCUMENT_SEARCH_CHANGE = 'PUBLICATION_DOCUMENT_SEARCH_CHANGE';

/********************GOB AWARD***********************************************************/
export const GOB_AWARD_LIST = 'GOB_AWARD_LIST';
export const GOB_AWARD_LIST_SUCCESS = 'GOB_AWARD_LIST_SUCCESS';
export const GOB_AWARD_LIST_ERROR = 'GOB_AWARD_LIST_ERROR';
export const GOB_AWARD_PAGE_SET = 'GOB_AWARD_PAGE_SET';
export const GOB_AWARD_HEADER = 'GOB_AWARD_HEADER';
export const GOB_AWARD_SEARCH_SET = 'GOB_AWARD_SEARCH_SET';
export const GOB_AWARD_SEARCH_CHANGE = 'GOB_AWARD_SEARCH_CHANGE';

/********************AWARD********************************************/
export const AWARD_LIST = 'AWARD_LIST';
export const AWARD_LIST_SUCCESS = 'AWARD_LIST_SUCCESS';
export const AWARD_LIST_ERROR = 'AWARD_LIST_ERROR';
export const AWARD_PAGE_SET = 'AWARD_PAGE_SET';
export const AWARD_HEADER = 'AWARD_HEADER';
export const AWARD_SEARCH_SET = 'AWARD_SEARCH_SET';
export const AWARD_SEARCH_CHANGE = 'AWARD_SEARCH_CHANGE';

/********************ACCESS VIEW********************************************/
export const ACCESS_VIEW = 'ACCESS_VIEW';
export const ACCESS_VIEW_SUCCESS = 'ACCESS_VIEW_SUCCESS';
export const ACCESS_VIEW_ERROR = 'ACCESS_VIEW_ERROR';
export const ACCESS_VIEW_MODAL_SET = 'ACCESS_VIEW_MODAL_SET';
export const ACCESS_VIEW_DETAIL = 'ACCESS_VIEW_DETAIL';
export const ACCESS_VIEW_DETAIL_SUCCESS = 'ACCESS_VIEW_DETAIL_SUCCESS';
export const ACCESS_VIEW_DETAIL_ERROR = 'ACCESS_VIEW_DETAIL_ERROR';
export const ACCESS_VIEW_SEARCH_SET = 'ACCESS_VIEW_SEARCH_SET';
export const ACCESS_VIEW_SEARCH_CHANGE = 'ACCESS_VIEW_SEARCH_CHANGE';

/********************ARTICLE LIST********************************************/
export const ARTICLE_LIST_ORP = 'ARTICLE_LIST_ORP';
export const ARTICLE_LIST_ORP_SUCCESS = 'ARTICLE_LIST_ORP_SUCCESS';
export const ARTICLE_LIST_ORP_ERROR = 'ARTICLE_LIST_ORP_ERROR';
export const ARTICLE_LIST_ORP_MODAL_SET = 'ARTICLE_LIST_ORP_MODAL_SET';
export const ARTICLE_LIST_ORP_SEARCH_SET = 'ARTICLE_LIST_ORP_SEARCH_SET';
export const ARTICLE_LIST_ORP_SEARCH_CHANGE = 'ARTICLE_LIST_ORP_SEARCH_CHANGE';
export const ARTICLE_LIST_ORP_VIEW_MODAL_SET = 'ARTICLE_LIST_ORP_VIEW_MODAL_SET';
export const ARTICLE_LIST_ORP_DETAIL = 'ARTICLE_LIST_ORP_DETAIL';
export const ARTICLE_LIST_ORP_DETAIL_SUCCESS = 'ARTICLE_LIST_ORP_DETAIL_SUCCESS';
export const ARTICLE_LIST_ORP_DETAIL_ERROR = 'ARTICLE_LIST_ORP_DETAIL_ERROR';

/********************SUPPLIER INFO********************************************/
export const SUPPLIER_INFO_LIST = 'SUPPLIER_INFO_LIST';
export const SUPPLIER_INFO_LIST_SUCCESS = 'SUPPLIER_INFO_LIST_SUCCESS';
export const SUPPLIER_INFO_LIST_ERROR = 'SUPPLIER_INFO_LIST_ERROR';
export const SUPPLIER_INFO_LIST_SEARCH_SET = 'SUPPLIER_INFO_LIST_SEARCH_SET';
export const SUPPLIER_INFO_LIST_SEARCH_CHANGE = 'SUPPLIER_INFO_LIST_SEARCH_CHANGE';

/********************RAZONABILIDAD********************************************/
export const RAZONABILIDAD_PRICE = 'RAZONABILIDAD_PRICE';
export const RAZONABILIDAD_PRICE_SUCCESS = 'RAZONABILIDAD_PRICE_SUCCESS';
export const RAZONABILIDAD_PRICE_ERROR = 'RAZONABILIDAD_PRICE_ERROR';
export const RAZONABILIDAD_PRICE_MODAL_SET = 'RAZONABILIDAD_PRICE_MODAL_SET';
export const RAZONABILIDAD_PRICE_SEARCH_SET = 'RAZONABILIDAD_PRICE_SEARCH_SET';
export const RAZONABILIDAD_PRICE_SEARCH_CHANGE = 'RAZONABILIDAD_PRICE_SEARCH_CHANGE';
export const RAZONABILIDAD_PRICE_DATA_SET = 'RAZONABILIDAD_PRICE_DATA_SET';
export const RAZONABILIDAD_PRICE_DATA_CHANGE = 'RAZONABILIDAD_PRICE_DATA_CHANGE';
export const RAZONABILIDAD_PRICE_DATA_TABLE = 'RAZONABILIDAD_PRICE_DATA_TABLE';
export const ARTICLE_YEAR_RAZONABILIDAD = 'ARTICLE_YEAR_RAZONABILIDAD';
export const ARTICLE_YEAR_RAZONABILIDAD_SUCCESS = 'ARTICLE_YEAR_RAZONABILIDAD_SUCCESS';
export const ARTICLE_YEAR_RAZONABILIDAD_ERROR = 'ARTICLE_YEAR_RAZONABILIDAD_ERROR';
export const SOURCE_RAZONABILIDAD = 'SOURCE_RAZONABILIDAD';
export const SOURCE_RAZONABILIDAD_SUCCESS = 'SOURCE_RAZONABILIDAD_SUCCESS';
export const SOURCE_RAZONABILIDAD_ERROR = 'SOURCE_RAZONABILIDAD_ERROR';

/********************ADMINISTRACION********************************************/
export const USER_ROLE_LIST = 'USER_ROLE_LIST';
export const USER_ROLE_LIST_SUCCESS = 'USER_ROLE_LIST_SUCCESS';
export const USER_ROLE_LIST_ERROR = 'USER_ROLE_LIST_ERROR';
export const USER_ROLE_PAGE_SET = 'USER_ROLE_PAGE_SET';
export const USER_ROLE_HEADER = 'USER_ROLE_HEADER';
export const USER_ROLE_SEARCH_SET = 'USER_ROLE_SEARCH_SET';
export const USER_ROLE_SEARCH_CHANGE = 'USER_ROLE_SEARCH_CHANGE';
export const USER_ROLE_MODAL_SET = 'USER_ROLE_MODAL_SET';
export const USER_ROLE_SET_DATA = 'USER_ROLE_SET_DATA';
export const USER_ROLE_SET_DATA_UPDATE = 'USER_ROLE_SET_DATA_UPDATE'
export const USER_ROLE_UPDATE = 'USER_ROLE_UPDATE';
export const USER_ROLE_UPDATE_SUCCESS = 'USER_ROLE_UPDATE_SUCCESS';
export const USER_ROLE_UPDATE_ERROR = 'USER_ROLE_UPDATE_ERROR';
export const USER_ROLE_TAB_SET = 'USER_ROLE_TAB_SET';
export const EXTERNAL_USER_ROLE_LIST = 'EXTERNAL_USER_ROLE_LIST';
export const EXTERNAL_USER_ROLE_LIST_SUCCESS = 'EXTERNAL_USER_ROLE_LIST_SUCCESS';
export const EXTERNAL_USER_ROLE_LIST_ERROR = 'EXTERNAL_USER_ROLE_LIST_ERROR';
export const EXTERNAL_USER_ROLE_SET_DATA = 'EXTERNAL_USER_ROLE_SET_DATA';
export const EXTERNAL_USER_ROLE_SET_DATA_UPDATE = 'EXTERNAL_USER_ROLE_SET_DATA_UPDATE'
export const EXTERNAL_USER_ROLE_UPDATE = 'EXTERNAL_USER_ROLE_UPDATE';
export const EXTERNAL_USER_ROLE_UPDATE_SUCCESS = 'EXTERNAL_USER_ROLE_UPDATE_SUCCESS';
export const EXTERNAL_USER_ROLE_UPDATE_ERROR = 'EXTERNAL_USER_ROLE_UPDATE_ERROR';
export const EXTERNAL_USER_ROLE_MODAL_SET = 'EXTERNAL_USER_ROLE_MODAL_SET';

/********************USER **********************************************************/
export const USER_ACTIONS_LIST = 'USER_ACTIONS_LIST';
export const USER_ACTIONS_LIST_SUCCESS = 'USER_ACTIONS_LIST_SUCCESS';
export const USER_ACTIONS_LIST_ERROR = 'USER_ACTIONS_LIST_ERROR';
export const USER_LIST = 'USER_LIST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_ERROR = 'USER_LIST_ERROR';
export const USER_LIST_PAGE_SET = 'USER_LIST_PAGE_SET';
export const USER_LIST_HEADER = 'USER_LIST_HEADER';
export const USER_LIST_SEARCH_SET = 'USER_LIST_SEARCH_SET';
export const USER_LIST_SEARCH_CHANGE = 'USER_LIST_SEARCH_CHANGE';
export const USER_LIST_MODAL_SET = 'USER_LIST_MODAL_SET';
export const USER_LIST_SET_DATA = 'USER_LIST_SET_DATA';
export const USER_LIST_SET_DATA_UPDATE = 'USER_LIST_SET_DATA_UPDATE'
export const USER_LIST_UPDATE = 'USER_LIST_UPDATE';
export const USER_LIST_UPDATE_SUCCESS = 'USER_LIST_UPDATE_SUCCESS';
export const USER_LIST_UPDATE_ERROR = 'USER_LIST_UPDATE_ERROR';
export const USER_LIST_TAB_SET = 'USER_LIST_TAB_SET';
export const USER_LIST_ADD_MODAL_SET = 'USER_LIST_ADD_MODAL_SET';
export const USER_LIST_ADD = 'USER_LIST_ADD';
export const USER_LIST_ADD_SUCCESS = 'USER_LIST_ADD_SUCCESS';
export const USER_LIST_ADD_ERROR = 'USER_LIST_ADD_ERROR';
export const USER_LIST_ADD_CHANGE = 'USER_LIST_ADD_CHANGE';
export const USER_LIST_ADD_SET = 'USER_LIST_ADD_SET';
export const EXTERNAL_USER_LIST = 'EXTERNAL_USER_LIST';
export const EXTERNAL_USER_LIST_SUCCESS = 'EXTERNAL_USER_LIST_SUCCESS';
export const EXTERNAL_USER_LIST_ERROR = 'EXTERNAL_USER_LIST_ERROR';
export const EXTERNAL_USER_LIST_PAGE_SET = 'EXTERNAL_USER_LIST_PAGE_SET';
export const EXTERNAL_USER_LIST_HEADER = 'EXTERNAL_USER_LIST_HEADER';
export const EXTERNAL_USER_LIST_SEARCH_SET = 'EXTERNAL_USER_LIST_SEARCH_SET';
export const EXTERNAL_USER_LIST_SEARCH_CHANGE = 'EXTERNAL_USER_LIST_SEARCH_CHANGE';
export const EXTERNAL_USER_LIST_MODAL_SET = 'EXTERNAL_USER_LIST_MODAL_SET';
export const EXTERNAL_USER_LIST_SET_DATA = 'EXTERNAL_USER_LIST_SET_DATA';
export const EXTERNAL_USER_LIST_SET_DATA_UPDATE = 'EXTERNAL_USER_LIST_SET_DATA_UPDATE'
export const EXTERNAL_USER_LIST_UPDATE = 'EXTERNAL_USER_LIST_UPDATE';
export const EXTERNAL_USER_LIST_UPDATE_SUCCESS = 'EXTERNAL_USER_LIST_UPDATE_SUCCESS';
export const EXTERNAL_USER_LIST_UPDATE_ERROR = 'EXTERNAL_USER_LIST_UPDATE_ERROR';
export const EXTERNAL_USER_LIST_ADD_MODAL_SET = 'EXTERNAL_USER_LIST_ADD_MODAL_SET';
export const EXTERNAL_USER_LIST_ADD = 'EXTERNAL_USER_LIST_ADD';
export const EXTERNAL_USER_LIST_ADD_SUCCESS = 'EXTERNAL_USER_LIST_ADD_SUCCESS';
export const EXTERNAL_USER_LIST_ADD_ERROR = 'EXTERNAL_USER_LIST_ADD_ERROR';
export const EXTERNAL_USER_LIST_ADD_CHANGE = 'EXTERNAL_USER_LIST_ADD_CHANGE';
export const EXTERNAL_USER_LIST_ADD_SET = 'EXTERNAL_USER_LIST_ADD_SET';


/*******************DATA QUALITY****************************************************/
export const DATA_QUALITY = 'DATA_QUALITY';
export const DATA_QUALITY_SUCCESS = 'DATA_QUALITY_SUCCESS';
export const DATA_QUALITY_ERROR = 'DATA_QUALITY_ERROR';
export const DATA_QUALITY_MODAL_SET = 'DATA_QUALITY_MODAL_SET';
export const DATA_QUALITY_DETAIL = 'DATA_QUALITY_DETAIL';
export const DATA_QUALITY_DETAIL_SUCCESS = 'DATA_QUALITY_DETAIL_SUCCESS';
export const DATA_QUALITY_DETAIL_ERROR = 'DATA_QUALITY_DETAIL_ERROR';
export const DATA_QUALITY_SEARCH_SET = 'DATA_QUALITY_SEARCH_SET';
export const DATA_QUALITY_SEARCH_CHANGE = 'DATA_QUALITY_SEARCH_CHANGE';
export const DATA_QUALITY_PAGE_SET = 'DATA_QUALITY_PAGE_SET';

/********************MENU ROLE*******************************************************/
export const MENU_ROLE = 'MENU_ROLE';
export const MENU_ROLE_SUCCESS = 'MENU_ROLE_SUCCESS';
export const MENU_ROLE_ERROR = 'MENU_ROLE_ERROR';

/*ARTICLE CARD*/
export const ARTICLE = 'ARTICLE';
export const ARTICLE_SUCCESS = 'ARTICLE_SUCCESS';
export const ARTICLE_ERROR = 'ARTICLE_ERROR';
export const ARTICLE_CARD_INFO = 'ARTICLE_CARD_INFO';
export const ARTICLE_CARD_INFO_SUCCESS = 'ARTICLE_CARD_INFO_SUCCESS';
export const ARTICLE_CARD_INFO_ERROR = 'ARTICLE_CARD_INFO_ERROR';
export const ARTICLE_CARD_SEARCH_SET = 'ARTICLE_CARD_SEARCH_SET';
export const ARTICLE_CARD_SEARCH_CHANGE = 'ARTICLE_CARD_SEARCH_CHANGE';
export const ARTICLE_CARD_TAB_SET = 'ARTICLE_CARD_TAB_SET';


export * from './menu/actions';
export * from './settings/actions';
export * from './catalogList/actions';
export * from './auth/actions';
export * from './activeIngredient/actions';
export * from './unit/actions';
export * from './dosageForm/actions';
export * from './dosageFormGroup/actions';
export * from './salt/actions';
export * from './dispensingUnit/actions';
export * from './routeAdministration/actions';
export * from './routeAdministrationGroup/actions';
export * from './dataMedication/actions';
export * from './atc/actions';
export * from './unspscFamily/actions';
export * from './unspscClass/actions';
export * from './unspsc/actions';
export * from './news/actions';
export * from './article/actions';
export * from './search/actions';
export * from './user/actions';
export * from './demand/actions';
export * from './acquisition/actions';
export * from './supplier/actions';
export * from './acquisitionDetail/actions';
export * from './code22/actions';
export * from './code22Review/actions';
export * from './dashboard/actions';
export * from './kpiMatrix/actions';
export * from './snapshot/actions';
export * from './orp/actions';
export * from './orpcompras/actions';
export * from './external_review/actions';
export * from './upload/actions';
export * from './adminUser/actions';
export * from './marketintelPrice/actions';
export * from './marketintelBid/actions';
export * from './marketintelArticle/actions';
export * from './marketintelSupplier/actions';
export * from './marketintelOpenning/actions';
export * from './publicationDocument/actions';
export * from './gobAward/actions';
export * from './award/actions';
export * from './accessView/actions';
export * from './articleList/actions';
export * from './supplierInfo/actions';
export * from './razonabilidad/actions';
export * from './userRole/actions';
export * from './dataQuality/actions';
export * from './menuRole/actions';
export * from './formKpiLcr/actions';
export * from './article_card/actions';
